/*
 * @license
 * Modular Theme (c) Presidio Creative Themes
 *
 * Modified versions of the theme code
 * are not supported by Presidio Creative.
 *
 */
!(function (t, e, i, s, o) {
    "use strict";
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.subscribers = {}),
        (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1320 }),
        (window.theme.dimensions = { headerScrolled: 60 }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        (window.theme.a11yTrigger = null),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return o && n;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != o && ((o = s), "function" == typeof i && i(s, t));
                    }
                    var o = e(t);
                    window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s);
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != o && ((o = s), "function" == typeof i && i(s, e));
                    }
                    var o = t(e);
                    window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s);
                },
            };
        })(),
        (window.theme.getWindowWidth = function () {
            return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
        }),
        (window.theme.getWindowHeight = function () {
            return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
        }),
        (window.theme.isMobile = function () {
            return window.theme.getWindowWidth() < window.theme.sizes.small;
        });
        (window.theme.isLarge = function () {
            return window.theme.getWindowWidth() < window.theme.sizes.large;
        });
    window.theme.PUB_SUB_EVENTS = {
        cartUpdate: "cart-update",
        quantityUpdate: "quantity-update",
        optionValueSelectionChange: "option-value-selection-change",
        variantChange: "variant-change",
        cartError: "cart-error",
    };
    let n = {};
    (window.publish = function (t, e) {
        if (n[t]) {
            const i = n[t].map((t) => t(e));
            return Promise.all(i);
        }
        return Promise.resolve();
    }),
        (window.subscribe = function (t, e) {
            return (
                void 0 === n[t] && (n[t] = []),
                (n[t] = [...n[t], e]),
                function () {
                    n[t] = n[t].filter((t) => t !== e);
                }
            );
        });
    const r = "[data-accordion]",
        a = "[data-accordion-trigger]",
        c = "[data-accordion-body]",
        l = "[data-accordion-content]",
        d = "input, button, a",
        h = "open",
        u = "single";
    let p = class extends HTMLElement {
        connectedCallback() {
            this.accordions.forEach((t) => {
                const e = t.querySelector(a),
                    i = t.querySelector(c);
                e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
                    i.addEventListener("transitionend", (e) => {
                        if (e.target === i) {
                            var s;
                            if ("true" == t.getAttribute(h))
                                this.setBodyHeight(i, "auto"),
                                    null === (s = t.querySelector(d)) || void 0 === s || s.focus();
                            "false" == t.getAttribute(h) && (t.removeAttribute(h), this.setBodyHeight(i, ""));
                        }
                    });
            }),
                this.addEventListener("keyup", (t) => this.onKeyUp(t));
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector(c),
                i = t.querySelector(l);
            t.setAttribute("open", !0), this.setBodyHeight(e, i.offsetHeight);
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector(c),
                i = t.querySelector(l);
            this.setBodyHeight(e, i.offsetHeight),
                t.setAttribute("open", !1),
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.setBodyHeight(e, 0);
                    });
                });
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = t.target.closest(r);
            this.hasAttribute(u) &&
                this.accordions.forEach((t) => {
                    t.hasAttribute(h) &&
                        t != e &&
                        requestAnimationFrame(() => {
                            this.close(t);
                        });
                }),
                e.hasAttribute(h) ? this.close(e) : this.open(e);
        }
        onKeyUp(t) {
            const e = this.querySelector("details[open]");
            "Escape" == t.code && e && e.querySelector("summary").dispatchEvent(new Event("click"));
        }
        constructor() {
            super(), (this.accordions = this.querySelectorAll(r));
        }
    };
    customElements.get("accordion-elements") || customElements.define("accordion-elements", p);
    function m() {
        const { windowHeight: t, headerInitialHeight: e, headerHeight: i, footerHeight: s } = theme.readHeights();
        document.documentElement.style.setProperty("--header-height", `${i}px`),
            document.documentElement.style.setProperty("--footer-height", `${s}px`),
            document.documentElement.style.setProperty("--content-full", t - i + "px"),
            document.documentElement.style.setProperty("--content-min", t - i - s + "px");
    }
    function v(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0;
    }
    (window.theme.formatMoney = function (t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let i = "";
        const s = /\{\{\s*(\w+)\s*\}\}/,
            o = e || "${{amount}}";
        function n(t, e = 2, i = ",", s = ".") {
            if (isNaN(t) || null == t) return 0;
            const o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (o[1] ? s + o[1] : "");
        }
        switch (o.match(s)[1]) {
            case "amount":
                i = n(t, 2);
                break;
            case "amount_no_decimals":
                i = n(t, 0);
                break;
            case "amount_with_comma_separator":
                i = n(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = n(t, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = n(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                i = n(t, 0, " ", "");
                break;
            case "amount_with_space_separator":
                i = n(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = n(t, 2, " ", ".");
        }
        return o.replace(s, i);
    }),
        (window.theme.debounce = function (t, e) {
            let i;
            return function () {
                if (t) {
                    const s = () => t.apply(this, arguments);
                    clearTimeout(i), (i = setTimeout(s, e));
                }
            };
        }),
        (function () {
            if (window.matchMedia("(orientation: portrait)").matches) return "portrait";
            if (window.matchMedia("(orientation: landscape)").matches);
        })(),
        (window.theme.readHeights = function () {
            const t = {};
            return (
                (t.windowHeight = window.innerHeight),
                (t.footerHeight = v('[data-section-type*="footer"]')),
                (t.headerHeight = v("[data-header-height].header--has-scrolled") || 60),
                (t.headerInitialHeight = v("[data-header-height]:not(.header--has-scrolled)")),
                t
            );
        }),
        m(),
        window.addEventListener("DOMContentLoaded", m),
        document.addEventListener("theme:resize", m),
        document.addEventListener("shopify:section:load", m);
    let f = class extends HTMLElement {
        loadContent(t = !0) {
            if ((window.theme.pauseAllMedia(), !this.getAttribute("loaded"))) {
                const e = document.createElement("div");
                e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
                    this.setAttribute("loaded", !0);
                const i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play();
            }
        }
        constructor() {
            super();
            const t = this.querySelector("[data-deferred-media-button]");
            null == t || t.addEventListener("click", this.loadContent.bind(this));
        }
    };
    customElements.get("deferred-media") || customElements.define("deferred-media", f),
        (window.theme.DeferredMedia = window.theme.DeferredMedia || f),
        customElements.get("collapsible-elements") ||
            customElements.define(
                "collapsible-elements",
                class extends HTMLElement {
                    connectedCallback() {
                        this.triggers.forEach((t) => {
                            t.addEventListener("click", (e) => this.collapsibleToggleEvent(e, t)),
                                t.addEventListener("keyup", (e) => this.collapsibleToggleEvent(e, t));
                        });
                    }
                    collapsibleToggleEvent(t, e) {
                        t.preventDefault();
                        const i = e.getAttribute("aria-controls"),
                            s = e.hasAttribute("data-accordion"),
                            o = document.getElementById(i),
                            n = e.parentNode,
                            r = n.classList.contains("is-expanded"),
                            a = "Space" === t.code,
                            c = "Escape" === t.code;
                        let l = o.querySelector("[data-collapsible-content]").offsetHeight;
                        if ((!t.code || a || c) && (r || !c)) {
                            if (r)
                                setTimeout(() => {
                                    (l = 0), this.setDropdownHeight(o, l, r);
                                }, 0);
                            else if (s) {
                                getSiblings(n).forEach((t) => {
                                    if (t.classList.contains("is-expanded")) {
                                        t.querySelector("[data-collapsible-trigger]").dispatchEvent(new Event("click"));
                                    }
                                });
                            }
                            e.setAttribute("aria-expanded", !r),
                                n.classList.toggle("is-expanded", !r),
                                this.setDropdownHeight(o, l, r);
                        }
                    }
                    setDropdownHeight(t, e, i) {
                        (t.style.maxHeight = `${e}px`), t.setAttribute("aria-hidden", i);
                        let s = "none";
                        this.resetHeight && clearTimeout(this.resetHeight),
                            0 === e && (s = null),
                            (this.resetHeight = setTimeout(() => {
                                t.style.maxHeight = s;
                            }, 500));
                    }
                    getSiblings(t) {
                        return Array.prototype.filter.call(t.parentNode.children, function (e) {
                            return e !== t;
                        });
                    }
                    constructor() {
                        super(),
                            (this.triggers = this.querySelectorAll("[data-collapsible-trigger]")),
                            (this.resetHeight = 0);
                    }
                }
            ),
        (window.theme.pauseAllMedia = function () {
            document.querySelectorAll('[data-host="youtube"]').forEach((t) => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            }),
                document.querySelectorAll('[data-host="vimeo"]').forEach((t) => {
                    t.contentWindow.postMessage('{"method":"pause"}', "*");
                }),
                document.querySelectorAll("video").forEach((t) => t.pause()),
                document.querySelectorAll("product-model").forEach((t) => {
                    t.modelViewerUI && t.modelViewerUI.pause();
                });
        }),
        customElements.get("product-form") ||
            customElements.define(
                "product-form",
                class extends HTMLElement {
                    onSubmitHandler(t) {
                        t.preventDefault(),
                            document.dispatchEvent(
                                new CustomEvent("theme:cart:add", {
                                    detail: { button: this.submitButton },
                                    bubbles: !1,
                                })
                            );
                        this.closest("quick-add-modal") || (window.a11y.lastElement = this.submitButton);
                    }
                    toggleSubmitButton(t = !0, e) {
                        t
                            ? (this.submitButton.setAttribute("disabled", "disabled"),
                              e && (this.submitButtonText.textContent = e))
                            : (this.submitButton.removeAttribute("disabled"),
                              (this.submitButtonText.textContent = window.theme.strings.addToCart));
                    }
                    get variantIdInput() {
                        return this.form.querySelector('[name="id"]');
                    }
                    constructor() {
                        super(),
                            (this.form = this.querySelector("form")),
                            (this.variantIdInput.disabled = !1),
                            theme.settings.enableAjaxCart && this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                            (this.cart = document.querySelector("cart-drawer")),
                            (this.submitButton = this.querySelector('[type="submit"]')),
                            (this.submitButtonText = this.submitButton.querySelector("[data-add-to-cart-text]")),
                            document.querySelector("cart-drawer") &&
                                this.submitButton.setAttribute("aria-haspopup", "dialog"),
                            (this.hideErrors = "true" === this.dataset.hideErrors);
                    }
                }
            ),
        customElements.get("popout-select") ||
            customElements.define(
                "popout-select",
                class extends HTMLElement {
                    connectedCallback() {
                        (this.popoutList = this.querySelector("[data-popout-list]")),
                            (this.popoutToggle = this.querySelector("[data-popout-toggle]")),
                            (this.popoutToggleText = this.querySelector("[data-popout-toggle-text]")),
                            (this.popoutInput =
                                this.querySelector("[data-popout-input]") ||
                                this.parentNode.querySelector("[data-popout-input]") ||
                                this.parentNode.parentNode.querySelector("[data-quantity-input]")),
                            (this.popoutOptions = this.querySelectorAll("[data-popout-option]")),
                            (this.productGridItem = this.popoutList.closest("[data-grid-item]")),
                            (this.fireSubmitEvent = this.hasAttribute("submit")),
                            (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
                            (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
                            (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
                            (this.keyUpEvent = (t) => this.onKeyUp(t)),
                            (this.bodyClickEvent = (t) => this.onBodyClick(t)),
                            this._connectOptions(),
                            this._connectToggle(),
                            this._onFocusOut(),
                            this.popupListSetDimensions();
                    }
                    onPopupToggleClick(t) {
                        const e = "true" === t.currentTarget.getAttribute("aria-expanded");
                        if (this.productGridItem) {
                            const t = this.productGridItem.querySelector("[data-product-image]");
                            t && t.classList.toggle("is-visible", !e),
                                (this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom)}px`);
                        }
                        t.currentTarget.setAttribute("aria-expanded", !e),
                            this.popoutList.classList.toggle("popout-list--visible"),
                            this.popupListSetDimensions(),
                            this.toggleListPosition(),
                            document.body.addEventListener("click", this.bodyClickEvent);
                    }
                    onPopupToggleFocusout(t) {
                        this.contains(t.relatedTarget) || this._hideList();
                    }
                    onPopupListFocusout(t) {
                        const e = t.currentTarget.contains(t.relatedTarget);
                        this.popoutList.classList.contains("popout-list--visible") && !e && this._hideList();
                    }
                    toggleListPosition() {
                        const t = this.querySelector("[data-popout-toggle]"),
                            e = this.getBoundingClientRect().top + this.clientHeight,
                            i = () => {
                                "true" !== t.getAttribute("aria-expanded") &&
                                    this.popoutList.classList.remove("popout-list--top"),
                                    this.popoutList.removeEventListener("transitionend", i);
                            };
                        "true" === t.getAttribute("aria-expanded")
                            ? window.innerHeight / 2 < e && this.popoutList.classList.add("popout-list--top")
                            : this.popoutList.addEventListener("transitionend", i);
                    }
                    popupListSetDimensions() {
                        this.popoutList.style.setProperty("--max-width", "100vw"),
                            this.popoutList.style.setProperty("--max-height", "100vh"),
                            requestAnimationFrame(() => {
                                this.popoutList.style.setProperty(
                                    "--max-width",
                                    `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`
                                ),
                                    this.popoutList.style.setProperty(
                                        "--max-height",
                                        `${parseInt(document.body.clientHeight - this.popoutList.getBoundingClientRect().top)}px`
                                    );
                            });
                    }
                    popupOptionsClick(t) {
                        if ("#" === t.target.closest("[data-popout-option]").attributes.href.value) {
                            t.preventDefault();
                            const e = t.currentTarget.hasAttribute("data-value")
                                ? t.currentTarget.getAttribute("data-value")
                                : "";
                            this.popoutInput.value = e;
                            const i = t.currentTarget.closest("li");
                            if (i) {
                                const t = i.getAttribute("data-option-value-id"),
                                    e = i.getAttribute("data-product-url");
                                t && this.popoutInput.setAttribute("data-option-value-id", t),
                                    e && this.popoutInput.setAttribute("data-product-url", e);
                            }
                            if (
                                (this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"),
                                this.fireSubmitEvent)
                            )
                                this._submitForm(e);
                            else {
                                const i = t.currentTarget.parentElement,
                                    s = this.popoutList.querySelector(".is-active"),
                                    o = this.popoutList.querySelector("[aria-current]");
                                this.popoutInput.dispatchEvent(new Event("change", { bubbles: !0 })),
                                    s && (s.classList.remove("is-active"), i.classList.add("is-active")),
                                    "quantity" != this.popoutInput.name ||
                                        i.nextSibling ||
                                        this.classList.add("is-active"),
                                    o &&
                                        o.hasAttribute("aria-current") &&
                                        (o.removeAttribute("aria-current"),
                                        t.currentTarget.setAttribute("aria-current", "true")),
                                    "" !== e &&
                                        ((this.popoutToggleText.innerHTML = e),
                                        this.popoutToggleText.hasAttribute("data-popout-toggle-text") &&
                                            "" !== this.popoutToggleText.getAttribute("data-popout-toggle-text") &&
                                            this.popoutToggleText.setAttribute("data-popout-toggle-text", e)),
                                    this.onPopupToggleFocusout(t),
                                    this.onPopupListFocusout(t);
                            }
                        }
                    }
                    onKeyUp(t) {
                        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
                    }
                    onBodyClick(t) {
                        const e = this.contains(t.target);
                        this.popoutList.classList.contains("popout-list--visible") && !e && this._hideList();
                    }
                    _connectToggle() {
                        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
                    }
                    _connectOptions() {
                        this.popoutOptions.length &&
                            this.popoutOptions.forEach((t) => {
                                t.addEventListener("click", (t) => this.popupOptionsClick(t));
                            });
                    }
                    _onFocusOut() {
                        this.addEventListener("keyup", this.keyUpEvent),
                            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                            this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);
                    }
                    _submitForm() {
                        const t = this.closest("form");
                        t && t.submit();
                    }
                    _hideList() {
                        this.popoutList.classList.remove("popout-list--visible"),
                            this.popoutToggle.setAttribute("aria-expanded", !1),
                            this.toggleListPosition(),
                            document.body.removeEventListener("click", this.bodyClickEvent);
                    }
                    constructor() {
                        super();
                    }
                }
            );
    const g = "[data-api-content]",
        y = "[data-product-template]";
    function w(t, e) {
        e = e || {};
        var i = t.tabIndex;
        (t.tabIndex = -1),
            (t.dataset.tabIndex = i),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function s(o) {
                o.target.removeEventListener(o.type, s),
                    (t.tabIndex = i),
                    delete t.dataset.tabIndex,
                    void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function b(t) {
        return Array.prototype.slice
            .call(
                t.querySelectorAll(
                    "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                )
            )
            .filter(function (t) {
                return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
            });
    }
    Shopify.Products = (function () {
        const t = { howManyToShow: 4, howManyToStoreInMemory: 10, wrapperId: "RecentlyViewed", onComplete: null };
        let e = [],
            i = null,
            s = null;
        const o = {
                configuration: { expires: 90, path: "/", domain: window.location.hostname },
                name: "shopify_recently_viewed",
                write: function (t) {
                    const e = t.join(" ");
                    document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                },
                read: function () {
                    let t = [],
                        e = null;
                    const i = document.querySelector(y);
                    if (
                        (-1 !== document.cookie.indexOf("; ") &&
                            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                            (e = document.cookie
                                .split("; ")
                                .find((t) => t.startsWith(this.name))
                                .split("=")[1]),
                        null !== e && (t = e.split(" ")),
                        i)
                    ) {
                        const e = i.getAttribute("data-product-handle");
                        if (-1 != t.indexOf(e)) {
                            const i = t.indexOf(e);
                            t.splice(i, 1);
                        }
                    }
                    return t;
                },
                destroy: function () {
                    document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                },
                remove: function (t) {
                    const e = this.read(),
                        i = e.indexOf(t);
                    -1 !== i && (e.splice(i, 1), this.write(e));
                },
            },
            n = (r) => {
                e.length && r < t.howManyToShow
                    ? fetch("/products/" + e[0] + "?section_id=api-product-grid-item")
                          .then((t) => t.text())
                          .then((t) => {
                              const s = document.createElement("div");
                              (s.innerHTML = t), (i.innerHTML += s.querySelector(g).innerHTML), e.shift(), r++, n(r);
                          })
                          .catch(() => {
                              o.remove(e[0]), e.shift(), n(r);
                          })
                    : (() => {
                          const e = o.read().length;
                          if (Shopify.recentlyViewed && s && e && e < s && i.children.length) {
                              let t = [],
                                  e = [],
                                  s = 0;
                              for (const i in Shopify.recentlyViewed) {
                                  s += 1;
                                  const n = Shopify.recentlyViewed[i].split(" "),
                                      r = parseInt(i.split("_")[1]);
                                  (t = [...t, ...n]),
                                      (o.read().length === r ||
                                          (s === Object.keys(Shopify.recentlyViewed).length && !e.length)) &&
                                          (e = [...e, ...n]);
                              }
                              for (let s = 0; s < i.children.length; s++) {
                                  const o = i.children[s];
                                  t.length && o.classList.remove(...t), e.length && o.classList.add(...e);
                              }
                          }
                          if (t.onComplete)
                              try {
                                  t.onComplete();
                              } catch (t) {
                                  console.log("error: ", t);
                              }
                      })();
            };
        return {
            showRecentlyViewed: function (r) {
                const a = r || {};
                Object.assign(t, a),
                    (e = o.read()),
                    (i = document.querySelector(`#${t.wrapperId}`)),
                    (s = t.howManyToShow),
                    (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
                    t.howManyToShow && i && n(0);
            },
            getConfig: function () {
                return t;
            },
            clearList: function () {
                o.destroy();
            },
            recordRecentlyViewed: function (e) {
                const i = e || {};
                Object.assign(t, i);
                let s = o.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    const e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                            )[0]
                            .split("/products/")[1],
                        i = s.indexOf(e);
                    -1 === i
                        ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
                        : (s.splice(i, 1), s.unshift(e)),
                        o.write(s);
                }
            },
            hasProducts: o.read().length > 0,
        };
    })();
    var E = {};
    function L() {
        document.removeEventListener("focusin", E.focusin),
            document.removeEventListener("focusout", E.focusout),
            document.removeEventListener("keydown", E.keydown);
    }
    var S = Object.freeze({
        __proto__: null,
        forceFocus: w,
        focusHash: function (t) {
            t = t || {};
            var e = window.location.hash,
                i = document.getElementById(e.slice(1));
            if (i && t.ignore && i.matches(t.ignore)) return !1;
            e && i && w(i, t);
        },
        bindInPageLinks: function (t) {
            return (
                (t = t || {}),
                Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                    if ("#" === e.hash || "" === e.hash) return !1;
                    if (t.ignore && e.matches(t.ignore)) return !1;
                    if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                    var i,
                        s = document.querySelector(e.hash);
                    return (
                        !!s &&
                        (e.addEventListener("click", function () {
                            w(s, t);
                        }),
                        !0)
                    );
                })
            );
        },
        focusable: b,
        trapFocus: function (t, e) {
            e = e || {};
            var i = b(t),
                s = e.elementToFocus || t,
                o = i[0],
                n = i[i.length - 1];
            L(),
                (E.focusin = function (e) {
                    t === e.target || t.contains(e.target) || o.focus(),
                        (e.target !== t && e.target !== n && e.target !== o) ||
                            document.addEventListener("keydown", E.keydown);
                }),
                (E.focusout = function () {
                    document.removeEventListener("keydown", E.keydown);
                }),
                (E.keydown = function (e) {
                    "Tab" === e.code &&
                        (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
                        (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
                }),
                document.addEventListener("focusout", E.focusout),
                document.addEventListener("focusin", E.focusin),
                w(s, e);
        },
        removeTrapFocus: L,
        accessibleLinks: function (t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var i,
                    s,
                    o,
                    n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    r = e.prefix || "a11y",
                    a = {
                        newWindow: r + "-new-window-message",
                        external: r + "-external-message",
                        newWindowExternal: r + "-new-window-external-message",
                    };
                t.forEach(function (t) {
                    var e = t.getAttribute("target"),
                        i = t.getAttribute("rel"),
                        s = (function (t) {
                            return t.hostname !== window.location.hostname;
                        })(t),
                        o = "_blank" === e,
                        n = null === i || -1 === i.indexOf("noopener");
                    if (o && n) {
                        var r = null === i ? "noopener" : i + " noopener";
                        t.setAttribute("rel", r);
                    }
                    s && o
                        ? t.setAttribute("aria-describedby", a.newWindowExternal)
                        : s
                          ? t.setAttribute("aria-describedby", a.external)
                          : o && t.setAttribute("aria-describedby", a.newWindow);
                }),
                    (i = n),
                    (s = document.createElement("ul")),
                    (o = Object.keys(i).reduce(function (t, e) {
                        return t + "<li id=" + a[e] + ">" + i[e] + "</li>";
                    }, "")),
                    s.setAttribute("hidden", !0),
                    (s.innerHTML = o),
                    document.body.appendChild(s);
            }
        },
    });
    customElements.get("header-component") ||
        customElements.define(
            "header-component",
            class extends HTMLElement {
                connectedCallback() {
                    document.documentElement.style.setProperty(
                        "--header-initial-height",
                        `${this.headerInitialHeight}px`
                    ),
                        this.resetHeader(),
                        this.checkTransparentHeader(),
                        this.checkNavigationOverlapping(),
                        this.cartToggleEvent(),
                        this.hideNav(),
                        this.bindings(),
                        this.activeLinks(),
                        document.addEventListener("theme:resize:width", this.checkNavOverlapEvent),
                        document.addEventListener("theme:resize:width", this.checkMobileNavEvent),
                        document.addEventListener("theme:header:update", this.checkTransparentHeaderEvent),
                        document.addEventListener("shopify:section:select", this.onSectionSelectEvent),
                        this.classList.contains("header--sticky") &&
                            (this.stickyHeaderState(),
                            document.addEventListener("theme:scroll", this.headerStateEvent));
                }
                cartToggleEvent() {
                    var t;
                    theme.settings.enableAjaxCart &&
                        (null === (t = this.querySelectorAll("[data-cart-toggle]")) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    const i = document.querySelector("cart-drawer");
                                    i &&
                                        (e.preventDefault(),
                                        i.dispatchEvent(new CustomEvent("theme:cart-drawer:show")),
                                        (window.a11y.lastElement = t));
                                });
                            }));
                }
                stickyHeaderState(t) {
                    const e = window.scrollY,
                        i = t && t.detail && t.detail.up;
                    (this.headerHeight = this.headerHeight || this.headerInitialHeight),
                        i && e < 2 * this.headerHeight
                            ? this.classList.add("header--is-hiding")
                            : this.classList.remove("header--is-hiding"),
                        e > this.headerHeight
                            ? (this.classList.add("header--has-scrolled"), this.classList.remove("header--transparent"))
                            : (this.classList.remove("header--has-scrolled"),
                              this.isHeaderTransparent() && this.classList.add("header--transparent"));
                }
                checkNavigationOverlapping() {
                    this.classList.remove("header--is-hamburger"),
                        this.classList.add("header--is-standard"),
                        (this.getNavigationOverlapping() || theme.isMobile() || theme.isLarge()) &&
                            (this.classList.remove("header--is-standard"), this.classList.add("header--is-hamburger"));
                }
                checkMobileNav() {
                    document.body.classList.contains("nav--is-visible") && !theme.isMobile() && this.resetHeader();
                }
                checkTransparentHeader() {
                    this.isHeaderTransparent()
                        ? (document.body.classList.add("has-transparent-header"),
                          this.classList.add("header--transparent"))
                        : (document.body.classList.remove("has-transparent-header"),
                          this.classList.remove("header--transparent"));
                }
                getNavigationOverlapping() {
                    const t = this.querySelector(".container > .row").offsetWidth,
                        e = this.getMenuItemsWidth(),
                        i = this.classList,
                        s =
                            i.contains("header--logo-center-links-center") ||
                            i.contains("header--logo-left-links-center"),
                        o = i.contains("header--logo-center-links-left");
                    let n = !1,
                        r = this.querySelector("[data-header-icons]").offsetWidth,
                        a = this.getLogoWidth();
                    return (
                        s && ((a = a < r ? r : a), (a *= 2), (r = 0)),
                        (n = parseInt(t) < parseInt(e + a + r + 40)),
                        o && a && (n = parseInt((t - a) / 2) < parseInt(e)),
                        n
                    );
                }
                getLogoWidth() {
                    const t = this.querySelector("[data-logo-image]"),
                        e = this.querySelector("[data-logo-text]");
                    let i = 0;
                    return (
                        null !== t && (i = parseInt(t.getAttribute("data-width"))),
                        null !== e && (i += e.offsetWidth),
                        i
                    );
                }
                getMenuItemsWidth() {
                    let t = 0;
                    return (
                        this.querySelector("[data-nav-main]")
                            .querySelectorAll(".menu > .menu-item")
                            .forEach((e) => {
                                t += this._outerWidth(e);
                            }),
                        t
                    );
                }
                isHeaderTransparent() {
                    const t = document.querySelector(".main-content").firstElementChild;
                    if (!t) return !1;
                    const e = null == t ? void 0 : t.classList.contains("header--full"),
                        i = null !== (null == t ? void 0 : t.querySelector('[data-header-style="transparent"]'));
                    return "true" === this.getAttribute("data-transparent") && (e || i);
                }
                resetHeader() {
                    const t = this.querySelector("[data-hamburger-icon]");
                    document.body.classList.remove("nav--is-visible"),
                        t.classList.remove("open"),
                        document.body.classList.contains("cart--is-visible") &&
                            document.querySelector("[data-cart-drawer-close]").click(),
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }
                bindings() {
                    const t = this.headerSection.querySelectorAll('[data-nav-main] a[href^="#"]'),
                        e = this.navStandard.querySelectorAll("[data-dropdown-parent]"),
                        i = [
                            ...this.headerSection.querySelectorAll("[data-nav-main] [data-collapsible-trigger]"),
                            ...t,
                        ];
                    this.menuToggles.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault(),
                                t.stopImmediatePropagation(),
                                document.body.classList.contains("nav--is-visible") ? this.hideNav() : this.showNav();
                        });
                    }),
                        e.forEach((t) => {
                            const e = t.querySelectorAll("[data-visible-link]");
                            t.addEventListener("mouseenter", () => {
                                theme.touched ||
                                    (t.classList.contains("menu-item--dropdown") ||
                                        this.header.classList.add("header--megamenu-visible"),
                                    t.classList.add("is-expanded"),
                                    e.forEach((t) => {
                                        t.removeAttribute("tabindex"),
                                            t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !0);
                                    }));
                            }),
                                t.addEventListener("mouseleave", () => {
                                    t.classList.contains("menu-item--dropdown") ||
                                        this.header.classList.remove("header--megamenu-visible"),
                                        t.classList.remove("is-expanded"),
                                        e.forEach((t) => {
                                            t.setAttribute("tabindex", "-1"),
                                                t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !1);
                                        });
                                });
                        }),
                        i.forEach((t) => {
                            t.addEventListener("click", () => {
                                t.parentNode.classList.contains("is-expanded")
                                    ? this.submenuClose(t.parentNode)
                                    : this.submenuOpen(t.parentNode);
                            }),
                                t.addEventListener("keyup", (e) => {
                                    "Space" === e.code
                                        ? t.parentNode.classList.contains("is-expanded")
                                            ? this.submenuClose(t.parentNode)
                                            : this.submenuOpen(t.parentNode)
                                        : "Escape" === e.code && this.submenuClose(t.parentNode);
                                });
                        }),
                        document.addEventListener("click", this.documentClick),
                        document.addEventListener("keyup", this.documentKeyup);
                }
                hideOnOutsideClick(t) {
                    const e = this.headerIcons.querySelector("[data-menu-toggle]").contains(t.target),
                        i = document.querySelector("[data-hamburger-scrollable]").parentNode.contains(t.target),
                        s = this.header.classList.contains("header--is-hamburger");
                    e || i || !s || this.hideNav();
                }
                hideOnKeyUp(t) {
                    const e = t.code,
                        i = t.target,
                        s = this.headerSection.querySelectorAll("[data-nav-main]")[1],
                        o = this.hamburger.classList.contains("open"),
                        n = document.querySelector("[data-dropdown-parent].is-expanded");
                    ("Tab" !== e && "Escape" !== e) ||
                        ("Tab" === e
                            ? (i.hasAttribute("data-menu-item-link") &&
                                  null !== n &&
                                  n.querySelector("[data-collapsible-trigger]").dispatchEvent(new Event("click")),
                              !s.contains(i) && o && this.hide())
                            : "Escape" === e &&
                              (null !== n &&
                                  n.querySelector("[data-collapsible-trigger]").dispatchEvent(new Event("click")),
                              o && this.hide()));
                }
                showNav() {
                    const t = this.headerIcons.querySelectorAll("a:not([data-menu-toggle])");
                    document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.scrollableElement })
                    ),
                        this.hamburger.classList.add("open"),
                        document.body.classList.add("nav--is-visible"),
                        t.forEach((t) => t.setAttribute("tabindex", "-1")),
                        this.hamburgerNavLinks.forEach((t) => t.removeAttribute("tabindex")),
                        this.menuToggles.forEach((t) => t.setAttribute("aria-expanded", !0));
                }
                hideNav() {
                    const t = this.headerIcons.querySelectorAll("a");
                    document.body.classList.contains("nav--is-visible") &&
                        (this.hamburger.classList.remove("open"),
                        document.body.classList.add("nav--is-hiding"),
                        document.body.classList.remove("nav--is-visible"),
                        this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
                        (this.scrollLockTimeout = setTimeout(() => {
                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                document.body.classList.remove("nav--is-hiding");
                        }, 500)),
                        t.forEach((t) => t.removeAttribute("tabindex")),
                        this.hamburgerNavLinks.forEach((t) => t.setAttribute("tabindex", "-1")),
                        this.menuToggles.forEach((t) => t.setAttribute("aria-expanded", !1)));
                }
                activeLinks() {
                    const t = this.navStandard.querySelectorAll("[data-menu-item-link]"),
                        e = this.navStandard.querySelectorAll("[data-visible-link]");
                    let i = !1;
                    t.forEach((t) => {
                        t.getAttribute("href") === window.location.pathname &&
                            (t.parentNode.classList.add("is-active"), (i = !0));
                    }),
                        i ||
                            e.forEach((t) => {
                                t.getAttribute("href") === window.location.pathname &&
                                    (t.parentNode.classList.add("is-active"),
                                    t.closest("[data-dropdown-parent]").classList.add("is-active"));
                            });
                }
                submenuClose(t) {
                    t.querySelectorAll("[data-visible-link]").forEach((t) => {
                        t.setAttribute("tabindex", "-1"),
                            t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !1);
                    }),
                        t.classList.contains("menu-item--meganav") &&
                            this.header.classList.remove("header--megamenu-visible");
                }
                submenuOpen(t) {
                    t.querySelectorAll("[data-visible-link]").forEach((t) => {
                        t.removeAttribute("tabindex"),
                            t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !0);
                    }),
                        t.classList.contains("menu-item--meganav") &&
                            this.header.classList.add("header--megamenu-visible");
                }
                disconnectedCallback() {
                    document.removeEventListener("theme:scroll", this.headerStateEvent),
                        document.removeEventListener("theme:resize:width", this.checkNavOverlapEvent),
                        document.removeEventListener("theme:resize:width", this.checkMobileNavEvent),
                        document.removeEventListener("theme:header:update", this.checkTransparentHeaderEvent),
                        document.removeEventListener("shopify:section:select", this.onSectionSelectEvent),
                        document.removeEventListener("click", this.documentClick),
                        document.removeEventListener("keyup", this.documentKeyup);
                }
                onSectionSelect() {
                    this.resetHeader(), this.init();
                }
                _outerWidth(t) {
                    const e = getComputedStyle(t);
                    let i = t.offsetWidth;
                    return (i += parseInt(e.marginLeft) + parseInt(e.marginRight)), i;
                }
                constructor() {
                    super(),
                        (this.headerContainer = this.parentNode),
                        (this.bodyWrap = document.querySelector("[data-body-wrap]"));
                    const { headerInitialHeight: t } = window.theme.readHeights();
                    (this.headerInitialHeight = t),
                        (this.headerStateEvent = (t) => this.stickyHeaderState(t)),
                        (this.checkMobileNavEvent = () => this.checkMobileNav()),
                        (this.checkNavOverlapEvent = () => this.checkNavigationOverlapping()),
                        (this.checkTransparentHeaderEvent = (t) => this.checkTransparentHeader(t)),
                        (this.onSectionSelectEvent = this.onSectionSelect.bind(this)),
                        (this.headerSection = this.closest(".shopify-section-header")),
                        (this.header = this.headerSection.querySelector("header-component")),
                        (this.menuToggles = this.headerSection.querySelectorAll("[data-menu-toggle]")),
                        (this.headerIcons = this.header.querySelector("[data-header-icons]")),
                        (this.navStandard = this.header.querySelector("[data-nav-main]")),
                        (this.hamburger = this.header.querySelector("[data-hamburger-icon]")),
                        (this.scrollableElement = document.querySelector("[data-hamburger-scrollable]")),
                        (this.hamburgerNavLinks = this.scrollableElement.parentNode.querySelectorAll("button, a")),
                        (this.documentClick = (t) => this.hideOnOutsideClick(t)),
                        (this.documentKeyup = (t) => this.hideOnKeyUp(t)),
                        (this.scrollLockTimeout = 0),
                        (this.resetHeight = 0),
                        (this.a11y = S),
                        window.addEventListener("load", this.checkNavOverlapEvent);
                }
            }
        );
    const k = "details",
        q = 'input:not([type="hidden"])',
        A = "[data-popdown]",
        C = "[data-popdown-close]",
        T = "[data-popdown-toggle]",
        x = "data-popdown-underlay",
        I = "has-search-popdown-visible";
    let M = class extends HTMLElement {
        connectedCallback() {
            this.popdownContainer.addEventListener("keyup", (t) => "Escape" === t.code && this.close()),
                this.popdownClose.addEventListener("click", this.close.bind(this)),
                this.popdownToggle.addEventListener("click", this.onPopdownToggleClick.bind(this)),
                this.popdownToggle.setAttribute("role", "button"),
                this.popdown.addEventListener("transitionend", (t) => {
                    "visibility" == t.propertyName &&
                        this.popdownContainer.hasAttribute("open") &&
                        "false" == this.popdownContainer.getAttribute("open") &&
                        this.closeCallback();
                });
        }
        onPopdownToggleClick(t) {
            t.preventDefault(), t.target.closest(k).hasAttribute("open") ? this.close() : this.open(t);
        }
        onBodyClick(t) {
            (this.contains(t.target) && !t.target.hasAttribute(x)) || this.close();
        }
        open(t) {
            (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                t.target.closest(k).setAttribute("open", ""),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.body.classList.add(I),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popdown })),
                requestAnimationFrame(() => {
                    t.target.closest(k).setAttribute("open", "true"),
                        this.popdown.addEventListener(
                            "transitionend",
                            (e) => {
                                e.target == this.popdown &&
                                    (this.a11y.trapFocus(this.popdown, {
                                        elementToFocus: this.popdown.querySelector(q),
                                    }),
                                    (theme.a11yTrigger = t.target));
                            },
                            { once: !0 }
                        );
                });
        }
        close() {
            this.popdownContainer.setAttribute("open", "false"),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        closeCallback() {
            this.popdownContainer.removeAttribute("open"),
                this.a11y.removeTrapFocus(),
                null !== theme.a11yTrigger && theme.a11yTrigger.focus(),
                document.body.classList.remove(I);
        }
        constructor() {
            super(),
                (this.popdown = this.querySelector(A)),
                (this.popdownContainer = this.querySelector(k)),
                (this.popdownToggle = this.querySelector(T)),
                (this.popdownClose = this.querySelector(C)),
                (this.a11y = S);
        }
    };
    customElements.define("header-search-popdown", M);
    const H = {},
        P = {
            forceFocus(t, e) {
                e = e || {};
                var i = t.tabIndex;
                (t.tabIndex = -1),
                    (t.dataset.tabIndex = i),
                    t.focus(),
                    void 0 !== e.className && t.classList.add(e.className),
                    t.addEventListener("blur", function s(o) {
                        o.target.removeEventListener(o.type, s),
                            (t.tabIndex = i),
                            delete t.dataset.tabIndex,
                            void 0 !== e.className && t.classList.remove(e.className);
                    });
            },
            focusHash(t) {
                t = t || {};
                var e = window.location.hash,
                    i = document.getElementById(e.slice(1));
                if (i && t.ignore && i.matches(t.ignore)) return !1;
                e && i && this.forceFocus(i, t);
            },
            bindInPageLinks(t) {
                return (
                    (t = t || {}),
                    Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                        if ("#" === e.hash || "" === e.hash) return !1;
                        if (t.ignore && e.matches(t.ignore)) return !1;
                        if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                        var i,
                            s = document.querySelector(e.hash);
                        return (
                            !!s &&
                            (e.addEventListener("click", () => {
                                this.forceFocus(s, t);
                            }),
                            !0)
                        );
                    })
                );
            },
            focusable(t) {
                return Array.prototype.slice
                    .call(
                        t.querySelectorAll(
                            "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                        )
                    )
                    .filter(
                        (t) => !(!(t.offsetWidth || t.offsetHeight || t.getClientRects().length) || !this.isVisible(t))
                    );
            },
            trapFocus(t, e) {
                e = e || {};
                var i = this.focusable(t),
                    s = e.elementToFocus || t,
                    o = i[0],
                    n = i[i.length - 1];
                this.removeTrapFocus(),
                    (H.focusin = function (e) {
                        t !== e.target && !t.contains(e.target) && o && o === e.target && o.focus(),
                            (e.target !== t && e.target !== n && e.target !== o) ||
                                document.addEventListener("keydown", H.keydown);
                    }),
                    (H.focusout = function () {
                        document.removeEventListener("keydown", H.keydown);
                    }),
                    (H.keydown = function (e) {
                        "Tab" === e.code &&
                            (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
                            (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
                    }),
                    document.addEventListener("focusout", H.focusout),
                    document.addEventListener("focusin", H.focusin),
                    this.forceFocus(s, e);
            },
            removeTrapFocus() {
                document.removeEventListener("focusin", H.focusin),
                    document.removeEventListener("focusout", H.focusout),
                    document.removeEventListener("keydown", H.keydown);
            },
            autoFocusLastElement() {
                window.a11y.lastElement &&
                    document.body.classList.contains("is-focused") &&
                    setTimeout(() => {
                        var t;
                        null === (t = window.a11y.lastElement) || void 0 === t || t.focus();
                    });
            },
            accessibleLinks(t, e) {
                if ("string" != typeof t) throw new TypeError(t + " is not a String.");
                if (0 !== (t = document.querySelectorAll(t)).length) {
                    (e = e || {}).messages = e.messages || {};
                    var i,
                        s,
                        o,
                        n = {
                            newWindow: e.messages.newWindow || "Opens in a new window.",
                            external: e.messages.external || "Opens external website.",
                            newWindowExternal:
                                e.messages.newWindowExternal || "Opens external website in a new window.",
                        },
                        r = e.prefix || "a11y",
                        a = {
                            newWindow: r + "-new-window-message",
                            external: r + "-external-message",
                            newWindowExternal: r + "-new-window-external-message",
                        };
                    t.forEach((t) => {
                        var e = t.getAttribute("target"),
                            i = t.getAttribute("rel"),
                            s = (function (t) {
                                return t.hostname !== window.location.hostname;
                            })(t),
                            o = "_blank" === e,
                            n = null === i || -1 === i.indexOf("noopener");
                        if (o && n) {
                            var r = null === i ? "noopener" : i + " noopener";
                            t.setAttribute("rel", r);
                        }
                        s && o
                            ? t.setAttribute("aria-describedby", a.newWindowExternal)
                            : s
                              ? t.setAttribute("aria-describedby", a.external)
                              : o && t.setAttribute("aria-describedby", a.newWindow);
                    }),
                        (i = n),
                        (s = document.createElement("ul")),
                        (o = Object.keys(i).reduce((t, e) => t + "<li id=" + a[e] + ">" + i[e] + "</li>", "")),
                        s.setAttribute("hidden", !0),
                        (s.innerHTML = o),
                        document.body.appendChild(s);
                }
            },
            isVisible(t) {
                var e = window.getComputedStyle(t);
                return "none" !== e.display && "hidden" !== e.visibility;
            },
        };
    (window.theme = window.theme || {}),
        (window.theme.a11y = P),
        (window.theme.throttle = (t, e) => {
            let i, s;
            return function o(...n) {
                const r = Date.now();
                (s = clearTimeout(s)),
                    !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
            };
        });
    let F = class extends HTMLElement {
        connectedCallback() {
            this.addEventListener("change", (t) => {
                const e = this.getInputForEventTarget(t.target);
                publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
                    data: { event: t, target: e, selectedOptionValues: this.selectedOptionValues },
                });
            });
        }
        getInputForEventTarget(t) {
            return "SELECT" === t.tagName ? t.selectedOptions[0] : t;
        }
        get selectedOptionValues() {
            return [
                ...Array.from(this.querySelectorAll("select option[selected]")),
                ...Array.from(this.querySelectorAll("fieldset input:checked")),
                ...Array.from(this.querySelectorAll("[data-popout-input]")),
            ]
                .map(({ dataset: t }) => t.optionValueId)
                .filter((t) => Boolean(t));
        }
        constructor() {
            super();
        }
    };
    customElements.define("variant-selects", F);
    window.HTMLUpdateUtility = class t {
        static viewTransition(e, i, s = [], o = []) {
            null == s || s.forEach((t) => t(i));
            const n = document.createElement("div");
            t.setInnerHTML(n, i.outerHTML);
            const r = n.firstChild,
                a = Date.now();
            e.querySelectorAll("[id], [form]").forEach((t) => {
                t.id && (t.id = `${t.id}-${a}`), t.form && t.setAttribute("form", `${t.form.getAttribute("id")}-${a}`);
            }),
                e.parentNode.insertBefore(r, e),
                (e.style.display = "none"),
                null == o || o.forEach((t) => t(r)),
                setTimeout(() => e.remove(), 500);
        }
        static setInnerHTML(t, e) {
            (t.innerHTML = e),
                t.querySelectorAll("script").forEach((t) => {
                    const e = document.createElement("script");
                    Array.from(t.attributes).forEach((t) => {
                        e.setAttribute(t.name, t.value);
                    }),
                        e.appendChild(document.createTextNode(t.innerHTML)),
                        t.parentNode.replaceChild(e, t);
                });
        }
    };
    let B = class extends HTMLElement {
        connectedCallback() {
            this.validateQtyRules(),
                (this.quantityUpdateUnsubscriber = subscribe(
                    theme.PUB_SUB_EVENTS.quantityUpdate,
                    this.validateQtyRules.bind(this)
                ));
        }
        disconnectedCallback() {
            this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
        }
        onInputChange(t) {
            this.validateQtyRules(), this.input && "updates[]" === this.input.name && this.updateCart();
        }
        onButtonClick(t) {
            var e, i;
            t.preventDefault();
            const s = this.input.value,
                o = "BUTTON" === t.target.nodeName ? t.target : t.target.closest("button"),
                n = o ? o.name : void 0,
                r = "decrease" === n || "minus" === n;
            var a, c;
            "increase" === n || "plus" === n
                ? parseInt(
                      null === (a = this.input) || void 0 === a || null === (c = a.dataset) || void 0 === c
                          ? void 0
                          : c.min
                  ) > parseInt(this.input.step) && 0 == this.input.value
                    ? (this.input.value = this.input.dataset.min)
                    : this.input.stepUp()
                : r && this.input.stepDown();
            s !== this.input.value && this.input.dispatchEvent(this.changeEvent),
                (null === (e = this.input) || void 0 === e || null === (i = e.dataset) || void 0 === i
                    ? void 0
                    : i.min) === s &&
                    r &&
                    (this.input.value = parseInt(this.input.min));
        }
        validateQtyRules() {
            const t = parseInt(this.input.value);
            if (this.input.min) {
                const e = this.querySelector("button[name='decrease']");
                e && e.classList.toggle("disabled", parseInt(t) <= parseInt(this.input.min));
            }
            if (this.input.max) {
                const e = parseInt(this.input.max),
                    i = this.querySelector("button[name='increase']");
                i && i.classList.toggle("disabled", t >= e);
            }
        }
        updateCart() {
            this.input &&
                "" !== this.input.value &&
                this.dispatchEvent(
                    new CustomEvent("theme:cart:update", {
                        bubbles: !0,
                        detail: { id: this.input.dataset.id, quantity: this.input.value },
                    })
                );
        }
        constructor() {
            var t, e, i;
            super(),
                (i = void 0),
                (e = "quantityUpdateUnsubscriber") in (t = this)
                    ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                    : (t[e] = i),
                (this.input = this.querySelector("input")),
                (this.changeEvent = new Event("change", { bubbles: !0 })),
                this.input.addEventListener("change", this.onInputChange.bind(this)),
                this.querySelectorAll("button").forEach((t) =>
                    t.addEventListener("click", this.onButtonClick.bind(this))
                );
        }
    };
    customElements.get("quantity-input") || customElements.define("quantity-input", B);
    const D = (t) => {
            const e = getComputedStyle(t);
            let i = t.offsetHeight;
            return (i += parseInt(e.marginTop) + parseInt(e.marginBottom)), i;
        },
        W = "[data-banner-container]",
        _ = "[data-banner-content]";
    function O(t) {
        const e = t.querySelectorAll(W);
        e &&
            e.forEach((t) => {
                const e = t.querySelector(_);
                e &&
                    ((t.style.minHeight = `${D(e)}px`),
                    document.addEventListener("theme:resize", () => {
                        t.style.minHeight = `${D(e)}px`;
                    }));
            });
    }
    function N(t) {
        t.querySelectorAll(".form-field").forEach((t) => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e &&
                i &&
                (i.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                i.value && i.value.length && e.classList.add("label--float"));
        });
    }
    let $ = window.theme.getWindowWidth(),
        R = window.theme.getWindowHeight();
    let V = window.scrollY,
        U = null,
        z = null,
        j = null,
        Q = null,
        X = 0;
    function K(e) {
        setTimeout(() => {
            X && clearTimeout(X),
                t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }),
                document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function Y(t) {
        const e = t.detail;
        e ? (X = setTimeout(G, e)) : G();
    }
    function G() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    const J = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return s.classList.add(e), t.parentNode.insertBefore(s, t), s.appendChild(t);
    };
    function Z(t) {
        t.querySelectorAll(".rte table").forEach((t) => {
            J(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "");
        });
        t.querySelectorAll(
            '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
        ).forEach((t) => {
            J(t, "rte__video-wrapper");
        });
    }
    function tt(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length &&
            e.forEach((t) => {
                t.addEventListener("click", function (t) {
                    t.preventDefault();
                    const e = t.currentTarget;
                    e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                    const i = e.getAttribute("aria-controls"),
                        s = document.querySelector(`#${i}`),
                        o = () => {
                            s.classList.remove("expanding"), s.removeEventListener("transitionend", o);
                        },
                        n = () => {
                            s.classList.add("expanding"), s.removeEventListener("transitionstart", n);
                        };
                    s.addEventListener("transitionstart", n),
                        s.addEventListener("transitionend", o),
                        s.classList.toggle("expanded");
                });
            });
    }
    const et = "is-loading",
        it = "img.is-loading";
    const st = "[data-aos]:not(.aos-animate)",
        ot = "[data-aos-anchor]",
        nt = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
        rt = "aos-animate",
        at = { attributes: !1, childList: !0, subtree: !0 };
    let ct = [];
    const lt = (t) => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        i = t.querySelectorAll(st),
                        s = t.querySelectorAll(ot);
                    i.length &&
                        i.forEach((t) => {
                            dt.observe(t);
                        }),
                        s.length && ut(s);
                }
        },
        dt = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.isIntersecting && (t.target.classList.add(rt), e.unobserve(t.target));
                });
            },
            { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
        ),
        ht = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    if (t.intersectionRatio) {
                        const i = t.target.querySelectorAll(st);
                        i.length &&
                            i.forEach((t) => {
                                t.classList.add(rt);
                            }),
                            e.unobserve(t.target);
                    }
                });
            },
            { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
        );
    function ut(t) {
        t.length &&
            !Shopify.visualPreviewMode &&
            t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                if (e && -1 === ct.indexOf(e)) {
                    const t = document.querySelector(e);
                    t && (ht.observe(t), ct.push(e));
                }
            });
    }
    (window.requestIdleCallback =
        window.requestIdleCallback ||
        function (t) {
            var e = Date.now();
            return setTimeout(function () {
                t({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - e));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            });
    "true" === document.body.getAttribute("data-animations") &&
        (!(function () {
            const t = document.querySelectorAll(nt);
            t.length &&
                t.forEach((t) => {
                    dt.observe(t);
                });
        })(),
        (function () {
            const t = document.querySelectorAll(ot);
            t.length && ut(t);
        })(),
        new MutationObserver(lt).observe(document.body, at),
        document.addEventListener("shopify:section:unload", (t) => {
            var e;
            const i =
                    "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
                s = ct.indexOf(i);
            -1 !== s && ct.splice(s, 1);
        })),
        window.addEventListener(
            "resize",
            window.theme.debounce(function () {
                document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
                    $ !== window.theme.getWindowWidth() &&
                        (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })),
                        ($ = window.theme.getWindowWidth())),
                    R !== window.theme.getWindowHeight() &&
                        (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })),
                        (R = window.theme.getWindowHeight()));
            }, 50)
        ),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.scrollY;
                                t > V ? ((z = !0), (U = !1)) : t < V ? ((z = !1), (U = !0)) : ((U = null), (z = null)),
                                    (V = t),
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll", {
                                            detail: { up: U, down: z, position: t },
                                            bubbles: !1,
                                        })
                                    ),
                                    U &&
                                        !j &&
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })
                                        ),
                                    z &&
                                        !Q &&
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:down", {
                                                detail: { position: t },
                                                bubbles: !1,
                                            })
                                        ),
                                    (Q = z),
                                    (j = U);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", K),
                window.addEventListener("theme:scroll:unlock", Y);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace(
                  "no-touch",
                  "supports-touch"
              )),
              (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                "img" == t.target.tagName.toLowerCase() &&
                    t.target.classList.contains(et) &&
                    (t.target.classList.remove(et),
                    t.target.parentNode.classList.remove(et),
                    t.target.parentNode.parentNode.classList.contains(et) &&
                        t.target.parentNode.parentNode.classList.remove(et));
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            N(document),
                O(document),
                tt(document),
                Z(document),
                document.querySelectorAll(it).forEach((t) => {
                    t.complete &&
                        (t.classList.remove(et),
                        t.parentNode.classList.remove(et),
                        t.parentNode.parentNode.classList.contains(et) && t.parentNode.parentNode.classList.remove(et));
                });
        }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            N(e),
                O(e),
                Z(e),
                tt(document),
                document.dispatchEvent(new CustomEvent("theme:header:update", { bubbles: !0 }));
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:update", { bubbles: !0 }));
        }),
        document.addEventListener("shopify:section:unload", () => {
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent("theme:header:update", { bubbles: !0 }));
            }, 200);
        });
    const pt = "is-focused",
        mt = "[data-skip-content]",
        vt = 'a[href="#"]';
    function ft(t) {
        (this.status = t.status || null),
            (this.headers = t.headers || null),
            (this.json = t.json || null),
            (this.body = t.body || null);
    }
    (window.a11y = new (class {
        init() {
            (this.a11y = window.theme.a11y),
                (this.html = document.documentElement),
                (this.body = document.body),
                (this.inPageLink = document.querySelector(mt)),
                (this.linkesWithOnlyHash = document.querySelectorAll(vt)),
                this.a11y.focusHash(),
                this.a11y.bindInPageLinks(),
                this.clickEvents(),
                this.focusEvents();
        }
        clickEvents() {
            this.inPageLink &&
                this.inPageLink.addEventListener("click", (t) => {
                    t.preventDefault();
                }),
                this.linkesWithOnlyHash &&
                    this.linkesWithOnlyHash.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                        });
                    });
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(pt);
            }),
                document.addEventListener("keyup", (t) => {
                    "Tab" === t.code && this.body.classList.add(pt);
                });
        }
        constructor() {
            this.init();
        }
    })()),
        (window.theme.waitForAnimationEnd = function (t) {
            return new Promise((e) => {
                null == t ||
                    t.addEventListener("animationend", function i(s) {
                        s.target == t && (t.removeEventListener("animationend", i), e());
                    });
            });
        }),
        (ft.prototype = Error.prototype);
    const gt = "is-added",
        yt = "is-disabled",
        wt = "is-empty",
        bt = "is-hidden",
        Et = "is-loading",
        Lt = "is-open",
        St = "is-removed",
        kt = "is-success",
        qt = "is-visible",
        At = "is-expanded",
        Ct = "is-updated",
        Tt = "variant--soldout",
        xt = "variant--unavailable",
        It = "cartToggle--empty",
        Mt = {
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiCartPrice: "[data-api-cart-price]",
            cartBarAdd: "[data-cart-bar-add-to-cart]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "cart-drawer",
            cartDrawerClose: "[data-cart-drawer-close]",
            cartEmpty: "[data-cart-empty]",
            cartErrors: "[data-cart-errors]",
            cartItemRemove: "[data-item-remove]",
            cartMessage: "[data-cart-message]",
            cartPage: "[data-cart-page]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemsCount: "[data-cart-items-count]",
            cartToggle: "[data-cart-toggle]",
            cartTotal: "[data-cart-total]",
            checkoutButtons: "[data-checkout-buttons]",
            emptyMessage: "[data-empty-message]",
            errorMessage: "[data-error-message]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            formWrapper: "[data-form-wrapper]",
            freeShipping: "[data-cart-message]",
            freeShippingProgress: "[data-cart-progress]",
            headerWrapper: "[data-header-wrapper]",
            item: "[data-item]",
            itemsHolder: "[data-items-holder]",
            leftToSpend: "[data-left-to-spend]",
            navDrawer: "[data-drawer]",
            outerSection: "[data-section-id]",
            priceHolder: "[data-cart-price-holder]",
            quickAddHolder: "[data-quick-add-holder]",
            quickAddModal: "[data-quick-add-modal]",
            qtyInput: 'input[name="updates[]"]',
            termsErrorMessage: "[data-terms-error-message]",
            collapsibleBody: "[data-collapsible-body]",
            discountInput: "[data-discount-input]",
            discountField: "[data-discount-field]",
            discountButton: "[data-apply-discount]",
            discountBody: "[data-discount-body]",
            discountCode: "[data-discount-code]",
            discountErrorMessage: "[data-discount-error-message]",
            removeDiscount: "[data-remove-discount]",
        },
        Ht = "data-cart-total",
        Pt = "disabled",
        Ft = "data-cart-message",
        Bt = "data-cart-total-price",
        Dt = "data-limit",
        Wt = "data-item",
        _t = "data-item-index",
        Ot = "data-item-title",
        Nt = "data-scroll-locked",
        $t = "data-max-inventory-reached",
        Rt = "data-error-message-position";
    let Vt = class extends HTMLElement {
        connectedCallback() {
            if (
                ((this.cartPage = document.querySelector(Mt.cartPage)),
                (this.cartForm = document.querySelector(Mt.cartForm)),
                (this.cartDrawer = document.querySelector(Mt.cartDrawer)),
                (this.cartEmpty = document.querySelector(Mt.cartEmpty)),
                (this.cartItemsCount = document.querySelector(Mt.cartItemsCount)),
                (this.cartTermsCheckbox = document.querySelector(Mt.cartTermsCheckbox)),
                (this.cartCheckoutButtonWrapper = document.querySelector(Mt.cartCheckoutButtonWrapper)),
                (this.cartCheckoutButton = document.querySelector(Mt.cartCheckoutButton)),
                (this.checkoutButtons = document.querySelector(Mt.checkoutButtons)),
                (this.itemsHolder = document.querySelector(Mt.itemsHolder)),
                (this.priceHolder = document.querySelector(Mt.priceHolder)),
                (this.items = document.querySelectorAll(Mt.item)),
                (this.cartTotal = document.querySelector(Mt.cartTotal)),
                (this.freeShipping = document.querySelectorAll(Mt.freeShipping)),
                (this.cartErrorHolder = document.querySelector(Mt.cartErrors)),
                (this.cartCloseErrorMessage = document.querySelector(Mt.cartCloseError)),
                (this.headerWrapper = document.querySelector(Mt.headerWrapper)),
                (this.navDrawer = document.querySelector(Mt.navDrawer)),
                (this.subtotal = window.theme.subtotal),
                (this.discountInput = document.querySelector(Mt.discountInput)),
                (this.discountField = document.querySelector(Mt.discountField)),
                (this.discountButton = document.querySelector(Mt.discountButton)),
                (this.hasDiscountBlock = Boolean(document.querySelector(Mt.discountButton))),
                (this.discountErrorMessage = document.querySelector(Mt.discountErrorMessage)),
                (this.existingDiscountCodes = []),
                (this.discounts = document.querySelectorAll(Mt.discountBody)),
                (this.emptyMessage = document.querySelector(Mt.emptyMessage)),
                (this.cartToggle = document.querySelector(Mt.cartToggle)),
                (this.cartMessage = document.querySelector(Mt.cartMessage)),
                (this.cart = this.cartDrawer || this.cartPage),
                this.hasDiscountBlock &&
                    (this.discountButton.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = this.discountInput.value.trim();
                        (this.discountInput.value = ""), e && this.applyDiscount(e);
                    }),
                    this.bindDiscountEventListeners()),
                (this.addToCart = this.addToCart.bind(this)),
                (this.cartAddEvent = this.cartAddEvent.bind(this)),
                (this.updateProgress = this.updateProgress.bind(this)),
                (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
                document.addEventListener("theme:cart:add", this.cartAddEvent),
                document.addEventListener("theme:announcement:init", this.updateProgress),
                theme.settings.enableAjaxCart ||
                    document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose),
                this.cartMessage)
            ) {
                this.cartFreeLimitShipping = Number(this.cartMessage.getAttribute(Dt)) * window.Shopify.currency.rate;
                const t = this.cartMessage.getAttribute(Bt);
                null !== t && (this.subtotal = Number(t)), this.updateProgress();
            }
            (this.circumference = 28 * Math.PI),
                (this.freeShippingLimit = this.freeShipping.length
                    ? Number(this.freeShipping[0].getAttribute(Dt)) * window.Shopify.currency.rate
                    : 0),
                this.freeShippingMessageHandle(this.subtotal),
                this.updateProgress(),
                (this.build = this.build.bind(this)),
                (this.updateCart = this.updateCart.bind(this)),
                (this.productAddCallback = this.productAddCallback.bind(this)),
                (this.formSubmitHandler = window.theme.throttle(this.formSubmitHandler.bind(this), 50)),
                this.cart &&
                    ((this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.cartCount = this.getCartItemCount())),
                (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                (this.totalItems = this.items.length),
                (this.showCannotAddMoreInCart = !1),
                (this.cartUpdateFailed = !1),
                (this.discountError = !1),
                this.cartEvents(),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                document.addEventListener("theme:product:add", this.productAddCallback),
                document.addEventListener("theme:product:add-error", this.productAddCallback),
                document.addEventListener("theme:cart:refresh", this.getCart.bind(this));
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent),
                document.removeEventListener("theme:cart:refresh", this.cartAddEvent),
                document.removeEventListener("theme:announcement:init", this.updateProgress),
                document.removeEventListener("theme:product:add", this.productAddCallback),
                document.removeEventListener("theme:product:add-error", this.productAddCallback),
                document.documentElement.hasAttribute(Nt) &&
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        onCartDrawerClose() {
            var t, e;
            ((null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(Lt)) &&
                this.cart.classList.remove(Ct),
            this.cartEmpty.classList.remove(Ct),
            this.cartErrorHolder.classList.remove(At),
            this.hasDiscountBlock) &&
                (null === (e = this.discountErrorMessage) || void 0 === e || e.classList.add("hidden"));
        } 
        cartUpdateEvents() {
            (this.items = document.querySelectorAll(Mt.item));
            
            if(this.items.length === 0){
                const alertDesc = document.querySelector(".alert_description");
                if (alertDesc) {
                    alertDesc.style.display = "none";
                }

                const productInfo = document.querySelector(".product__info");
                if (productInfo) {
                    productInfo.classList.remove("hide__remains_element");
                }
            }
            let hasInStorePickup = false;
             let hasShippingProduct = false;

                this.items.forEach((t) => {
                     const title_cart = t.getAttribute("data-item-title") || "";
                     const isInStorePickup = title_cart.includes("PICKUP & DELIVERY");

                   
                    if (title_cart.includes("PICKUP & DELIVERY")) {
                            hasInStorePickup = true;
                    }

                    if (!title_cart.includes("PICKUP & DELIVERY")) {
                        hasShippingProduct = true;
                    }
                      

                    t.addEventListener("theme:cart:update", (e) => {
                        this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                    });
                   
                });

            // new code
                const alertDesc = document.querySelector(".alert_description");
                const productInfo = document.querySelector(".product__info");

                const currentProductTitle =
                    (document.querySelector(".product__title")?.innerText || "");

                    
                const currentIsPickup = currentProductTitle.includes("PICKUP & DELIVERY");

                const shouldBlock =
                    (hasInStorePickup && !currentIsPickup && hasShippingProduct === false) ||
                    (hasShippingProduct && currentIsPickup && hasInStorePickup === false);

                if (shouldBlock) {
                    if (alertDesc) alertDesc.style.display = "block";
                    if (productInfo) productInfo.classList.add("hide__remains_element");
                    return;
                }

                if (alertDesc) alertDesc.style.display = "none";
                if (productInfo) productInfo.classList.remove("hide__remains_element");

        }
        cartRemoveEvents() {
            document.querySelectorAll(Mt.cartItemRemove).forEach((t) => {
                const e = t.closest(Mt.item);
                t.addEventListener("click", (i) => {
                    i.preventDefault(),
                        t.classList.contains(yt) || this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
                });
            }),
                this.cartCloseErrorMessage &&
                    this.cartCloseErrorMessage.addEventListener("click", (t) => {
                        t.preventDefault(), this.cartErrorHolder.classList.remove(At);
                    });
        }
        cartAddEvent(t) {
            let e = "",
                i = t.detail.button;
            if (i.hasAttribute("disabled")) return;
            const s = i.form || i.closest("form");
            if (!s.checkValidity()) return void s.reportValidity();
            if (((e = new FormData(s)), null !== s && s.querySelector('[type="file"]'))) return;
            theme.settings.enableAjaxCart && this.cartDrawer && t.preventDefault();
            const o = s.getAttribute($t),
                n = s.getAttribute(Rt);
            (this.showCannotAddMoreInCart = !1),
                "true" === o && "cart" === n && (this.showCannotAddMoreInCart = !0),
                this.addToCart(e, i);
        }
        bindDiscountEventListeners() {
            this.hasDiscountBlock &&
                ((this.discounts = document.querySelectorAll(Mt.discountBody)),
                this.discounts.forEach((t) => {
                    const e = t.dataset.discountCode;
                    this.existingDiscountCodes.includes(e) || this.existingDiscountCodes.push(e);
                    const i = t.querySelector(Mt.removeDiscount);
                    i &&
                        (i.removeEventListener("click", this.handleRemoveDiscount),
                        i.addEventListener("click", (t) => {
                            t.preventDefault(), this.removeDiscount(e);
                        }));
                }));
        }
        applyDiscount(t) {
            if (this.existingDiscountCodes.includes(t))
                return (
                    this.discountErrorMessage.classList.remove("hidden"),
                    void (this.discountErrorMessage.textContent = window.theme.strings.discount_already_applied)
                );
            this.existingDiscountCodes.push(t), this.updateCartDiscounts(this.existingDiscountCodes.join(","));
        }
        removeDiscount(t) {
            this.existingDiscountCodes.includes(t) &&
                ((this.existingDiscountCodes = this.existingDiscountCodes.filter((e) => e !== t)),
                this.updateCartDiscounts(this.existingDiscountCodes.join(",")));
        }
        updateCartDiscounts(t) {
            var e;
            const i =
                null ===
                    (e = t
                        .split(",")
                        .filter((t) => t)
                        .pop()) || void 0 === e
                    ? void 0
                    : e.trim();
            this.disableCartButtons(),
                this.discountErrorMessage.classList.add("hidden"),
                fetch(window.theme.routes.cart_update_url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify({ discount: t }),
                })
                    .then((t) => {
                        if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
                        return t.text();
                    })
                    .then((t) => {
                        let e;
                        try {
                            e = JSON.parse(t);
                        } catch (e) {
                            throw (
                                (console.error("Failed to parse cart update response:", t),
                                new Error("Invalid JSON response from server."))
                            );
                        }
                        if (i) {
                            e.discount_codes &&
                            Array.isArray(e.discount_codes) &&
                            e.discount_codes.some((t) => t.code === i && t.applicable)
                                ? (this.discountError = !1)
                                : ((this.discountError = !0),
                                  (this.existingDiscountCodes = this.existingDiscountCodes.filter((t) => t !== i)));
                        } else this.discountError = !1;
                        this.getCart();
                    })
                    .catch((t) => {
                        console.log(t);
                    });
        }
        cartEvents() {
            this.cartTermsCheckbox &&
                (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                this.cartForm.addEventListener("submit", this.formSubmitHandler));
        }
        formSubmitHandler() {
            const t = document.querySelector(Mt.cartTermsCheckbox).checked,
                e = document.querySelector(Mt.termsErrorMessage);
            if (t) e.classList.remove(At), this.cartCheckoutButton.removeAttribute(Pt);
            else {
                if (document.querySelector(Mt.termsErrorMessage).length > 0) return;
                (e.innerText = theme.strings.cartAcceptanceError),
                    this.cartCheckoutButton.setAttribute(Pt, !0),
                    e.classList.add(At);
            }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(Mt.formCloseError);
            null == e ||
                e.addEventListener("click", (e) => {
                    e.preventDefault(), t && t.classList.remove(qt);
                });
        }
        getCart() {
            fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                .then(this.cartErrorsHandler)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const i = e.querySelector(Mt.apiContent);
                    this.build(i);
                })
                .catch((t) => console.log(t));
        }
        addToCart(t, e) {
            this.cart && this.cart.classList.add(Et);
            const i = null == e ? void 0 : e.closest(Mt.quickAddHolder),
                s = e.closest("product-form").querySelector('input[name="quantity"]').value || 1;
            e && (e.classList.add(Et), (e.disabled = !0)),
                i && i.classList.add(qt),
                fetch(theme.routes.cart_add_url, {
                    method: "POST",
                    headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
                    body: t,
                })
                    .then((t) => t.json())
                    .then((t) => {
                        (t.status &&
                            (this.addToCartError(t, e),
                            e &&
                                (e.classList.remove(Et),
                                (e.disabled = !1),
                                e.dispatchEvent(
                                    new CustomEvent("theme:product:add-error", {
                                        detail: { response: t, button: e, quantity: s },
                                        bubbles: !0,
                                    })
                                )),
                            !this.showCannotAddMoreInCart)) ||
                            (this.cart
                                ? (e &&
                                      (e.classList.remove(Et),
                                      e.classList.add(gt),
                                      e.dispatchEvent(
                                          new CustomEvent("theme:product:add", {
                                              detail: { response: t, button: e, quantity: s },
                                              bubbles: !0,
                                          })
                                      )),
                                  theme.settings.enableAjaxCart || (window.location = theme.routes.cart_url),
                                  this.getCart())
                                : (window.location = theme.routes.cart_url));
                    })
                    .catch((t) => {
                        this.addToCartError(t, e), this.enableCartButtons();
                    });
        }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(Et);
            let i = t.quantity;
            null !== e && (i ? e.classList.add(Et) : e.classList.add(St)), this.disableCartButtons();
            const s = this.cart.querySelector(`[${Wt}="${t.id}"]`) || e,
                o = (null == s ? void 0 : s.hasAttribute(_t)) ? parseInt(s.getAttribute(_t)) : 0,
                n = (null == s ? void 0 : s.hasAttribute(Ot)) ? s.getAttribute(Ot) : null;
            if (0 === o) return;
            const r = { line: o, quantity: i };
            fetch(theme.routes.cart_change_url, {
                method: "post",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(r),
            })
                .then((t) => t.text())
                .then((t) => {
                    if (JSON.parse(t).errors)
                        return (
                            (this.cartUpdateFailed = !0),
                            this.updateErrorText(n),
                            this.toggleErrorMessage(),
                            this.resetLineItem(e),
                            this.enableCartButtons(),
                            void this.bindDiscountEventListeners()
                        );
                    this.getCart();
                })
                .catch((t) => {
                    console.log(t), this.enableCartButtons();
                });
        }
        resetLineItem(t) {
            const e = t.querySelector(Mt.qtyInput),
                i = e.getAttribute("value");
            (e.value = i), t.classList.remove(Et);
        }
        disableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${Mt.cartItemRemove}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.add(yt), t.blur(), (t.disabled = !0);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.setAttribute(Pt, !0);
                    });
        }
        enableCartButtons() {
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${Mt.cartItemRemove}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.remove(yt), (t.disabled = !1);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.removeAttribute(Pt);
                    }),
                this.cart.classList.remove(Et);
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(Mt.errorMessage).innerText = t;
        }
        toggleErrorMessage() {
            this.cartErrorHolder &&
                (this.cartErrorHolder.classList.toggle(At, this.cartUpdateFailed || this.showCannotAddMoreInCart),
                (this.showCannotAddMoreInCart = !1),
                (this.cartUpdateFailed = !1));
        }
        cartErrorsHandler(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new ft({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        hideAddToCartErrorMessage() {
            const t = this.button.closest(Mt.productForm),
                e = null == t ? void 0 : t.querySelector(Mt.formErrorsContainer);
            null == e || e.classList.remove(qt);
        }
        addToCartError(t, e) {
            var i;
            if (this.showCannotAddMoreInCart) return;
            if (null !== e) {
                const i = e.closest(Mt.outerSection) || e.closest(Mt.quickAddHolder) || e.closest(Mt.quickAddModal);
                let s = null == i ? void 0 : i.querySelector(Mt.formErrorsContainer);
                if (s) {
                    let e = `${t.message}: ${t.description}`;
                    t.message == t.description && (e = t.message),
                        (s.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><path d="M.5.5l26 26M26.5.5l-26 26"></path></svg></button></div>`),
                        s.classList.add(qt),
                        this.formErrorsEvents(s);
                }
                e.dispatchEvent(
                    new CustomEvent("theme:product:add-error", { detail: { response: t, button: e }, bubbles: !0 })
                ),
                    this.getCart();
            }
            const s = null == e ? void 0 : e.closest(Mt.quickAddHolder);
            s &&
                s.dispatchEvent(
                    new CustomEvent("theme:cart:error", {
                        bubbles: !0,
                        detail: { message: t.message, description: t.description, holder: s },
                    })
                ),
                null === (i = this.cart) || void 0 === i || i.classList.remove(Et);
        }
        productAddCallback(t) {
            let e = [],
                i = null;
            const s = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(Mt.cartBarAdd);
            e.push(o),
                (i = o.closest(Mt.quickAddHolder)),
                n && e.push(n),
                e.forEach((t) => {
                    t.classList.remove(Et), s || t.classList.add(gt);
                }),
                setTimeout(() => {
                    e.forEach((t) => {
                        var e, i;
                        t.classList.remove(gt);
                        (null === (e = t.closest(Mt.formWrapper)) || void 0 === e
                            ? void 0
                            : e.classList.contains(Tt)) ||
                            (null === (i = t.closest(Mt.formWrapper)) || void 0 === i
                                ? void 0
                                : i.classList.contains(xt)) ||
                            (t.disabled = !1);
                    }),
                        null == i || i.classList.remove(qt);
                }, 1e3);
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cartToggle.classList.toggle(It, !t),
                this.emptyMessage.classList.toggle(bt, t),
                this.cart.classList.toggle(wt, !t),
                !t &&
                    this.cartDrawer &&
                    setTimeout(() => {
                        this.a11y.trapFocus(this.cartDrawer, {
                            elementToFocus: this.cartDrawer.querySelector(Mt.cartDrawerClose),
                        });
                    }, 100);
        }
        build(t) {

            var e;
            const i = t.querySelector(Mt.apiLineItems),
                s = Boolean(null === i),
                o = t.querySelector(Mt.apiCartPrice),
                n = t.querySelector(Mt.cartTotal);
            this.priceHolder && o && (this.priceHolder.innerHTML = o.innerHTML),
                (this.itemsHolder.innerHTML = s ? t.innerHTML : i.innerHTML),
                (this.newTotalItems = i && i.querySelectorAll(Mt.item).length ? i.querySelectorAll(Mt.item).length : 0),
                (this.subtotal = n && n.hasAttribute(Ht) ? parseInt(n.getAttribute(Ht)) : 0),
                (this.cartCount = this.getCartItemCount()),
                document.dispatchEvent(
                    new CustomEvent("theme:cart:change", { bubbles: !0, detail: { cartCount: this.cartCount } })
                );
            const r = this.getCartItemCount();
            this.cartItemsCount &&
                (r > 0 && this.newTotalItems > 0
                    ? (this.cartItemsCount.innerText = r < 10 ? r : "9+")
                    : (this.cartItemsCount.innerText = "0")),
                (this.cartTotal.innerHTML =
                    0 === this.subtotal
                        ? window.theme.strings.free
                        : window.theme.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                this.totalItems !== this.newTotalItems &&
                    ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(Lt)) &&
                    this.cart.classList.add(Ct),
                this.cart.classList.remove(Et),
                this.hasDiscountBlock &&
                    (this.discountField && (this.discountField.value = this.existingDiscountCodes.join(",")),
                    this.discountError
                        ? ((this.discountErrorMessage.textContent = window.theme.strings.discount_not_applicable),
                          this.discountErrorMessage.classList.remove("hidden"))
                        : this.discountErrorMessage.classList.add("hidden")),
                this.freeShippingMessageHandle(this.subtotal),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                this.toggleErrorMessage(),
                this.enableCartButtons(),
                this.updateProgress(),
                this.bindDiscountEventListeners(),
                document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: !0 }));

                console.log(t);
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(Mt.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0);
        }
        hasItemsInCart() {
            return this.totalItems > 0;
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length &&
                this.freeShipping.forEach((e) => {
                    const i = e.hasAttribute(Ft) && "true" === e.getAttribute(Ft) && t >= 0;
                    e.classList.toggle(kt, i && t >= this.freeShippingLimit);
                });
        }
        updateProgress() {
            if (((this.freeShipping = document.querySelectorAll(Mt.freeShipping)), !this.freeShipping.length)) return;
            const t = this.freeShippingLimit > 0 ? this.subtotal / this.freeShippingLimit : 0,
                e = Math.max(0, Math.min(100 * t, 100)),
                i = Math.max(0, this.freeShippingLimit - this.subtotal),
                s = window.theme.formatMoney(i, theme.moneyFormat);
            this.freeShipping.forEach((t) => {
                const i = t.querySelector(Mt.freeShippingProgress),
                    o = t.querySelector(Mt.leftToSpend);
                o && (o.innerHTML = s.replace(".00", "")),
                    i && (i.setAttribute("data-percent", `${e}`), i.style.setProperty("--percent", `${e}`));
            });
        }
        constructor() {
            super(), (this.a11y = window.theme.a11y);
        }
    };
    customElements.get("cart-items") || customElements.define("cart-items", Vt);
    let Ut = class extends HTMLElement {
        connectedCallback() {
            (window.theme.hasCartDrawer = !0),
                this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
                document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
                document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
                document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer),
                document.removeEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.querySelectorAll("cart-drawer").length <= 1 && (window.theme.hasCartDrawer = !1),
                (function () {
                    if (document.querySelector("cart-items")) return;
                    const t = document.createElement("cart-items");
                    document.body.appendChild(t);
                })();
        }
        openCartDrawerOnProductAdded() {
            this.cartDrawerIsOpen || this.openCartDrawer();
        }
        openCartDrawer(t = !1) {
            t &&
                ((this.cartDrawerIsOpen = !0),
                (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(
                    new CustomEvent("theme:cart-drawer:open", { detail: { target: this }, bubbles: !0 })
                ),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartScroll })),
                this.classList.add("is-open"),
                this.observeAdditionalCheckoutButtons(),
                window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
                    this.a11y.trapFocus(this, { elementToFocus: this.querySelector("[data-cart-drawer-close]") });
                }));
        }
        closeCartDrawer() {
            this.classList.contains("is-open") &&
                (this.classList.remove("is-open"),
                (this.cartDrawerIsOpen = !1),
                document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })),
                this.a11y.removeTrapFocus(),
                this.a11y.autoFocusLastElement(),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (t) => {
                t.preventDefault(), this.closeCartDrawer();
            }),
                this.addEventListener("keyup", (t) => {
                    "Escape" === t.code && this.closeCartDrawer();
                });
        }
        onBodyClick(t) {
            t.target.hasAttribute("data-drawer-underlay") && this.closeCartDrawer();
        }
        observeAdditionalCheckoutButtons() {
            const t = this.querySelector(".additional-checkout-buttons");
            if (t) {
                const e = new MutationObserver(() => {
                    this.a11y.trapFocus(this, { elementToFocus: this.querySelector("[data-cart-drawer-close]") }),
                        e.disconnect();
                });
                e.observe(t, { subtree: !0, childList: !0 });
            }
        }
        constructor() {
            super(),
                (this.cartDrawerIsOpen = !1),
                (this.cartDrawerClose = this.querySelector("[data-cart-drawer-close]")),
                (this.cartDrawerInner = this.querySelector("[data-cart-drawer-inner]")),
                (this.openCartDrawer = this.openCartDrawer.bind(this)),
                (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                (this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this)),
                (this.cartDrawerSection = this.closest(".shopify-section")),
                (this.cartScroll = document.querySelector("[data-cart-scroll]")),
                (this.a11y = window.theme.a11y),
                this.closeCartEvents();
        }
    };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", Ut);
    let zt = class extends HTMLElement {
        connectedCallback() {
            (this.popoverHolder = this.querySelector("[data-popover]")),
                (this.popoverTemplate = this.querySelector("[data-popover-template]")),
                this.popoverHolder.addEventListener("click", () => {
                    const t = document.querySelector("cart-drawer");
                    t && t.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
                });
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:add", this.showPopoverOnProductAdd),
                document.removeEventListener("theme:product:add-error", this.showPopoverOnProductAdd);
        }
        renderPopover(t, e) {
            const i = document.importNode(this.popoverTemplate.content, !0),
                s = i.querySelector("[data-popover-heading]"),
                o = i.querySelector("[data-popover-image]"),
                n = i.querySelector("[data-popover-title]"),
                r = i.querySelector("[data-popover-variant]"),
                a = i.querySelector("[data-popover-selling-plan]"),
                c = i.querySelector("[data-popover-item-props]"),
                l = i.querySelector("[data-popover-item-price]"),
                d = i.querySelector("[data-popover-unit-price]");
            if (t.status)
                i.querySelector(".popover-inner").classList.add("errors"),
                    (i.querySelector(".popover-inner").innerHTML = t.message);
            else {
                const i = t,
                    h = /(<([^>]+)>)/gi,
                    u = i.title.replace(h, "");
                let p =
                        0 === i.final_price
                            ? window.theme.strings.free
                            : window.theme.formatMoney(i.final_price, theme.settings.moneyFormat),
                    m = theme.assets.no_image,
                    v = "";
                const f = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : null;
                let g = "";
                if (
                    (i.unit_price_measurement &&
                        ((v = `${window.theme.formatMoney(i.unit_price, theme.moneyWithoutCurrencyFormat)} / `),
                        1 != i.unit_price_measurement.reference_value &&
                            (v += i.unit_price_measurement.reference_value),
                        (v += i.unit_price_measurement.reference_unit)),
                    null != i.featured_image && (m = i.featured_image.url),
                    i.properties)
                )
                    for (const t in i.properties)
                        if ({}.hasOwnProperty.call(i.properties, t)) {
                            const e = i.properties[t],
                                s = t.slice(0, 1);
                            e && "_" !== s && (g += "<p>" + t + ": " + i.properties[t] + "</p>");
                        }
                s.innerHTML = `(${e}) ${u} ${s.innerHTML}`;
                const y = document.createElement("img");
                (y.src = `${m}&width=240`),
                    (y.alt = u),
                    (y.width = 120),
                    (y.height = 120),
                    (y.sizes = "120px"),
                    (y.srcset = `${m}&width=120 1x, ${m}&width=180 1.5x, ${m}&width=240 2x`),
                    o.appendChild(y),
                    (n.innerHTML = u),
                    (r.innerHTML = i.product_has_only_default_variant ? "" : i.variant_title),
                    (a.innerHTML = f || ""),
                    (c.innerHTML = g),
                    (l.innerHTML = p),
                    (d.innerHTML = v);
            }
            const h = document.createElement("div");
            h.appendChild(i);
            const u = h.innerHTML;
            return h.remove(), u;
        }
        showPopover(t) {
            const e = t.detail.response,
                i = t.detail.quantity;
            theme.isMobile() ||
                ((this.popoverHolder.innerHTML = this.renderPopover(e, i)),
                this.popoverHolder.classList.add("is-visible"),
                clearTimeout(this.popoverTimer),
                (this.popoverTimer = setTimeout(() => {
                    this.hidePopover();
                }, 3e3)));
        }
        hidePopover() {
            this.popoverHolder.classList.remove("is-visible"),
                setTimeout(() => {
                    this.popoverHolder.innerHtml = "";
                }, 300);
        }
        constructor() {
            super(),
                (this.popoverTimer = ""),
                (this.showPopoverOnProductAdd = this.showPopover.bind(this)),
                document.addEventListener("theme:product:add", this.showPopoverOnProductAdd),
                document.addEventListener("theme:product:add-error", this.showPopoverOnProductAdd);
        }
    };
    customElements.get("cart-popover") || customElements.define("cart-popover", zt);
    const jt = 'input[type="search"]',
        Qt = '[aria-selected="true"] a',
        Xt = 'button[type="reset"]',
        Kt = "hidden";
    let Yt = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(Kt);
            this.input.value.length > 0 && t
                ? this.resetButton.classList.remove(Kt)
                : 0 !== this.input.value.length || t || this.resetButton.classList.add(Kt);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(Qt);
        }
        onFormReset(t) {
            t.preventDefault(),
                this.shouldResetForm() &&
                    ((this.input.value = ""), this.toggleResetButton(), t.target.querySelector(jt).focus());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(jt)),
                (this.resetButton = this.querySelector(Xt)),
                this.input &&
                    (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        window.theme
                            .debounce((t) => {
                                this.onChange(t);
                            }, 300)
                            .bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", Yt);
    const Gt = 'input[type="search"]';
    customElements.define(
        "main-search",
        class extends Yt {
            setupEventListeners() {
                let t = [];
                this.allSearchInputs.forEach((e) => t.push(e.form)),
                    this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                    t.length < 2 ||
                        (t.forEach((t) => t.addEventListener("reset", this.onFormReset.bind(this))),
                        this.allSearchInputs.forEach((t) => t.addEventListener("input", this.onInput.bind(this))));
            }
            onFormReset(t) {
                super.onFormReset(t), super.shouldResetForm() && this.keepInSync("", this.input);
            }
            onInput(t) {
                const e = t.target;
                this.keepInSync(e.value, e);
            }
            onInputFocus() {
                window.theme.isMobile() && this.scrollIntoView({ behavior: "smooth" });
            }
            keepInSync(t, e) {
                this.allSearchInputs.forEach((i) => {
                    i !== e && (i.value = t);
                });
            }
            constructor() {
                super(), (this.allSearchInputs = document.querySelectorAll(Gt)), this.setupEventListeners();
            }
        }
    );
    const Jt = '[role="option"]',
        Zt = '[aria-selected="true"]',
        te = "predictive-search",
        ee = "[data-predictive-search-results]",
        ie = "[data-predictive-search-status]",
        se = 'input[type="search"]',
        oe = "[data-popdown]",
        ne = "[data-predictive-search-live-region-count-value]",
        re = "data-search-results-groups-wrapper",
        ae = "[data-predictive-search-search-for-text]",
        ce = "#shopify-section-predictive-search",
        le = '[aria-selected="true"] a',
        de = '[aria-selected="true"] a, button[aria-selected="true"]';
    customElements.define(
        "predictive-search",
        class extends Yt {
            connectedCallback() {
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                    this.addEventListener("focusout", this.onFocusOut.bind(this)),
                    this.addEventListener("keyup", this.onKeyup.bind(this)),
                    this.addEventListener("keydown", this.onKeydown.bind(this));
            }
            getQuery() {
                return this.input.value.trim();
            }
            onChange() {
                super.onChange();
                const t = this.getQuery();
                var e;
                (this.searchTerm && t.startsWith(this.searchTerm)) ||
                    null === (e = this.querySelector(re)) ||
                    void 0 === e ||
                    e.remove();
                this.updateSearchForTerm(this.searchTerm, t),
                    (this.searchTerm = t),
                    this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
            }
            onFormSubmit(t) {
                (this.getQuery().length && !this.querySelector(le)) || t.preventDefault();
            }
            onFormReset(t) {
                super.onFormReset(t),
                    super.shouldResetForm() &&
                        ((this.searchTerm = ""),
                        this.abortController.abort(),
                        (this.abortController = new AbortController()),
                        this.closeResults(!0));
            }
            shouldResetForm() {
                return !document.querySelector(le);
            }
            onFocus() {
                const t = this.getQuery();
                t.length &&
                    (this.searchTerm !== t
                        ? this.onChange()
                        : "true" === this.getAttribute("results")
                          ? this.open()
                          : this.getSearchResults(this.searchTerm));
            }
            onFocusOut() {
                setTimeout(() => {
                    this.contains(document.activeElement) || this.close();
                });
            }
            onKeyup(t) {
                switch ((this.getQuery().length || this.close(!0), t.preventDefault(), t.code)) {
                    case "ArrowUp":
                        this.switchOption("up");
                        break;
                    case "ArrowDown":
                        this.switchOption("down");
                        break;
                    case "Enter":
                        this.selectOption();
                }
            }
            onKeydown(t) {
                ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
            }
            updateSearchForTerm(t, e) {
                const i = this.querySelector(ae),
                    s = null == i ? void 0 : i.innerText;
                if (s) {
                    var o;
                    if ((null === (o = s.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                    const n = s.replace(t, e);
                    i.innerText = n;
                }
            }
            switchOption(t) {
                if (!this.getAttribute("open")) return;
                const e = "up" === t,
                    i = this.querySelector(Zt),
                    s = Array.from(this.querySelectorAll(Jt)).filter((t) => null !== t.offsetParent);
                let o = 0;
                if (e && !i) return;
                let n = -1,
                    r = 0;
                for (; -1 === n && r <= s.length; ) s[r] === i && (n = r), r++;
                if (
                    ((this.statusElement.textContent = ""),
                    !e && i ? (o = n === s.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? s.length - 1 : n - 1),
                    o === n)
                )
                    return;
                const a = s[o];
                a.setAttribute("aria-selected", !0),
                    i && i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-activedescendant", a.id);
            }
            selectOption() {
                const t = this.querySelector(de);
                t && t.click();
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase();
                this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(
                              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`,
                              { signal: this.abortController.signal }
                          )
                              .then((t) => {
                                  if (!t.ok) {
                                      var e = new Error(t.status);
                                      throw (this.close(), e);
                                  }
                                  return t.text();
                              })
                              .then((t) => {
                                  const i = new DOMParser().parseFromString(t, "text/html").querySelector(ce).innerHTML;
                                  this.allPredictiveSearchInstances.forEach((t) => {
                                      t.cachedResults[e] = i;
                                  }),
                                      this.renderSearchResults(i);
                              })
                              .catch((t) => {
                                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                              });
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector(ie)),
                    (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                    this.setLiveRegionText(this.loadingText),
                    this.setAttribute("loading", !0);
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute("aria-hidden", "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute("aria-hidden", "true");
                    }, 1e3);
            }
            renderSearchResults(t) {
                (this.predictiveSearchResults.innerHTML = t),
                    this.setAttribute("results", !0),
                    this.setLiveRegionResults(),
                    this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(ne).textContent);
            }
            getResultsMaxHeight() {
                return (
                    (this.resultsMaxHeight =
                        window.theme.getWindowHeight() - document.querySelector(oe).getBoundingClientRect().bottom),
                    this.resultsMaxHeight
                );
            }
            open() {
                (this.predictiveSearchResults.style.maxHeight =
                    this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`),
                    this.setAttribute("open", !0),
                    this.input.setAttribute("aria-expanded", !0),
                    (this.isOpen = !0);
            }
            close(t = !1) {
                this.closeResults(t), (this.isOpen = !1);
            }
            closeResults(t = !1) {
                var e;
                t && ((this.input.value = ""), this.removeAttribute("results"));
                const i = this.querySelector(Zt);
                i && i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-activedescendant", ""),
                    this.removeAttribute("loading"),
                    this.removeAttribute("open"),
                    this.input.setAttribute("aria-expanded", !1),
                    (this.resultsMaxHeight = !1),
                    null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style");
            }
            reset() {
                (this.predictiveSearchResults.innerHTML = ""), (this.input.val = ""), this.a11y.removeTrapFocus();
            }
            constructor() {
                super(),
                    (this.a11y = S),
                    (this.abortController = new AbortController()),
                    (this.allPredictiveSearchInstances = document.querySelectorAll(te)),
                    (this.cachedResults = {}),
                    (this.input = this.querySelector(se)),
                    (this.isOpen = !1),
                    (this.predictiveSearchResults = this.querySelector(ee)),
                    (this.searchPopdown = this.closest(oe)),
                    (this.searchTerm = "");
            }
        }
    ),
        (Shopify.Products = (function () {
            const t = {
                howManyToShow: 4,
                howManyToStoreInMemory: 10,
                wrapperId: "recently-viewed-products",
                section: null,
                target: "api-product-grid-item",
                onComplete: null,
            };
            let e = [],
                i = null,
                s = null;
            const o = new Date(),
                n = new Date();
            n.setTime(o.getTime() + 7776e6);
            const r = {
                    configuration: {
                        expires: n.toGMTString(),
                        path: "/",
                        domain: window.location.hostname,
                        sameSite: "none",
                        secure: !0,
                    },
                    name: "shopify_recently_viewed",
                    write: function (t) {
                        const e = encodeURIComponent(t.join(" "));
                        document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
                    },
                    read: function () {
                        let t = [],
                            e = null;
                        return (
                            -1 !== document.cookie.indexOf("; ") &&
                                document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                                (e = document.cookie
                                    .split("; ")
                                    .find((t) => t.startsWith(this.name))
                                    .split("=")[1]),
                            null !== e && (t = decodeURIComponent(e).split(" ")),
                            t
                        );
                    },
                    destroy: function () {
                        document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
                    },
                    remove: function (t) {
                        const e = this.read(),
                            i = e.indexOf(t);
                        -1 !== i && (e.splice(i, 1), this.write(e));
                    },
                },
                a = (e, i, o, n, c, l) => {
                    i.length && e < l
                        ? fetch(`${window.theme.routes.root}products/${i[0]}?section_id=${c}`)
                              .then((t) => t.text())
                              .then((t) => {
                                  const s = 100 * e,
                                      r = o.id ? `#${o.id}` : "",
                                      d = document.createElement("div");
                                  let h = t;
                                  (h = h.includes("||itemAnimationDelay||")
                                      ? h.replaceAll("||itemAnimationDelay||", s)
                                      : h),
                                      (h = h.includes("||itemAnimationAnchor||")
                                          ? h.replaceAll("||itemAnimationAnchor||", r)
                                          : h),
                                      (d.innerHTML = h),
                                      (o.innerHTML += d.querySelector("[data-api-content]").innerHTML),
                                      i.shift(),
                                      e++,
                                      a(e, i, o, n, c, l);
                              })
                              .catch(() => {
                                  r.remove(i[0]), i.shift(), a(e, i, o, n, c, l);
                              })
                        : ((e, i) => {
                              e.classList.remove("hidden");
                              const o = r.read().length;
                              if (Shopify.recentlyViewed && s && o && o < s && e.children.length) {
                                  let t = [],
                                      i = [],
                                      s = 0;
                                  for (const e in Shopify.recentlyViewed) {
                                      s += 1;
                                      const o = Shopify.recentlyViewed[e].split(" "),
                                          n = parseInt(e.split("_")[1]);
                                      (t = [...t, ...o]),
                                          (r.read().length === n ||
                                              (s === Object.keys(Shopify.recentlyViewed).length && !i.length)) &&
                                              (i = [...i, ...o]);
                                  }
                                  for (let s = 0; s < e.children.length; s++) {
                                      const o = e.children[s];
                                      t.length && o.classList.remove(...t), i.length && o.classList.add(...i);
                                  }
                              }
                              if (t.onComplete)
                                  try {
                                      t.onComplete(e, i);
                                  } catch (t) {
                                      console.log(t);
                                  }
                          })(o, n);
                };
            return {
                showRecentlyViewed: function (o) {
                    if (Shopify.visualPreviewMode) return;
                    const n = o || {};
                    Object.assign(t, n),
                        (e = r.read()),
                        (i = document.querySelector(`#${t.wrapperId}`)),
                        (s = t.howManyToShow),
                        (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
                        t.howManyToShow && i && a(0, e, i, t.section, t.target, s);
                },
                getConfig: function () {
                    return t;
                },
                clearList: function () {
                    r.destroy();
                },
                recordRecentlyViewed: function (e) {
                    const i = e || {};
                    Object.assign(t, i);
                    let s = r.read();
                    if (-1 !== window.location.pathname.indexOf("/products/")) {
                        let e = decodeURIComponent(window.location.pathname)
                            .match(
                                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
                            )[0]
                            .split("/products/")[1];
                        t.handle && (e = t.handle);
                        const i = s.indexOf(e);
                        -1 === i
                            ? (s.unshift(e), (s = s.splice(0, t.howManyToStoreInMemory)))
                            : (s.splice(i, 1), s.unshift(e)),
                            r.write(s);
                    }
                },
                hasProducts: r.read().length > 0,
            };
        })()),
        (window.theme.scrollTo = (t) => {
            const e = document.querySelector(".header-sticky")
                ? document.querySelector("[data-header-height]").offsetHeight
                : 0;
            window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
        }),
        customElements.get("tooltip-component") ||
            customElements.define(
                "tooltip-component",
                class extends HTMLElement {
                    connectedCallback() {
                        if (!document.querySelector(".tooltip-default")) {
                            const t =
                                    '<div class="tooltip-default__arrow"></div><div class="tooltip-default__inner"><div class="tooltip-default__text"></div></div>',
                                e = document.createElement("div");
                            (e.className = "tooltip-default"), (e.innerHTML = t), document.body.appendChild(e);
                        }
                        this.addEventListener("mouseenter", this.addPinMouseEvent),
                            this.addEventListener("mouseleave", this.removePinMouseEvent),
                            this.addEventListener("pointerleave", this.removePinMouseEvent),
                            this.addEventListener("theme:tooltip:init", this.addPinEvent),
                            document.addEventListener("theme:tooltip:close", this.removePinEvent),
                            (this.onVariantChangeUnsubscriber = subscribe(
                                theme.PUB_SUB_EVENTS.optionValueSelectionChange,
                                this.removePin.bind(this, !0, !1)
                            ));
                    }
                    addPin(t = !1) {
                        const e = document.querySelector(".tooltip-default");
                        if (this.label && e && ((t && !this.hasAttribute("data-tooltip-stop-mouseenter")) || !t)) {
                            const t = e.querySelector(".tooltip-default__arrow"),
                                i = e.querySelector(".tooltip-default__inner");
                            e.querySelector(".tooltip-default__text").innerHTML = this.label;
                            const s = i.offsetWidth,
                                o = this.getBoundingClientRect(),
                                n = o.top,
                                r = o.width,
                                a = n + o.height + window.scrollY;
                            let c = o.left - s / 2 + r / 2;
                            const l = 24,
                                d = c + s - window.theme.getWindowWidth() + l;
                            d > 0 && (c -= d),
                                c < 0 && (c = 0),
                                (t.style.left = `${o.left + r / 2}px`),
                                e.style.setProperty("--tooltip-top", `${a}px`),
                                (i.style.transform = `translateX(${c}px)`),
                                e.classList.remove("is-hiding"),
                                e.classList.add("is-visible"),
                                document.addEventListener("theme:scroll", this.removePinEvent);
                        }
                    }
                    removePin(t, e = !1, i = !1) {
                        const s = document.querySelector(".tooltip-default"),
                            o = s.classList.contains("is-visible");
                        s &&
                            ((e && !this.hasAttribute("data-tooltip-stop-mouseenter")) || !e) &&
                            (o &&
                                (i || (t && t.detail && t.detail.hideTransition)) &&
                                (s.classList.add("is-hiding"),
                                this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                                (this.hideTransitionTimeout = setTimeout(() => {
                                    s.classList.remove("is-hiding");
                                }, this.transitionSpeed))),
                            s.classList.remove("is-visible"),
                            document.removeEventListener("theme:scroll", this.removePinEvent));
                    }
                    disconnectedCallback() {
                        this.onVariantChangeUnsubscriber(),
                            document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                            document.removeEventListener("theme:scroll", this.removePinEvent);
                    }
                    constructor() {
                        super(),
                            (this.label = this.hasAttribute("data-tooltip") ? this.getAttribute("data-tooltip") : ""),
                            (this.transitionSpeed = 200),
                            (this.hideTransitionTimeout = 0),
                            (this.addPinEvent = () => this.addPin()),
                            (this.addPinMouseEvent = () => this.addPin(!0)),
                            (this.removePinEvent = (t) => window.theme.throttle(this.removePin(t), 50)),
                            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0));
                    }
                }
            ),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const he = window.Shopify.theme.sections.registered,
        ue = window.Shopify.theme.sections.instances,
        pe = "data-section-id",
        me = "data-section-type";
    let ve = class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t)
                            throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = {
                        onLoad: [],
                        onUnload: [],
                        onSelect: [],
                        onDeselect: [],
                        onBlockSelect: [],
                        onBlockDeselect: [],
                        onReorder: [],
                    }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i
                                ? t.push(i)
                                : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`),
                                  console.warn(i));
                        }
                    });
            }
        },
        fe = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    const i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                (this.container = (function (t) {
                    if (!(t instanceof Element))
                        throw new TypeError(
                            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
                        );
                    if (null === t.getAttribute(pe))
                        throw new Error(
                            "Theme Sections: The section container provided does not have an id assigned to the " +
                                pe +
                                " attribute."
                        );
                    return t;
                })(t)),
                    (this.id = t.getAttribute(pe)),
                    (this.type = e.type),
                    (this.callStack = e.getStack());
                try {
                    this.onLoad();
                } catch (t) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
                }
            }
        };
    function ge(t, e) {
        if ("string" != typeof t)
            throw new TypeError(
                "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
            );
        if (void 0 !== he[t])
            throw new Error(
                'Theme Sections: A section of type "' +
                    t +
                    '" has already been registered. You cannot register the same section type twice'
            );
        Array.isArray(e) || (e = [e]);
        const i = new ve(t, e);
        return (he[t] = i), he;
    }
    function ye(t, e) {
        (t = Ee(t)),
            void 0 === e && (e = document.querySelectorAll("[" + me + "]")),
            (e = Le(e)),
            t.forEach(function (t) {
                const i = he[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return (
                            !(we(e).length > 0) &&
                            null !== e.getAttribute(me) &&
                            (e.getAttribute(me) !== t || (ue.push(new fe(e, i)), !1))
                        );
                    }));
            });
    }
    function we(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            Le(t).forEach(function (t) {
                e = e.concat(
                    ue.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            Ee(t).forEach(function (t) {
                e = e.concat(
                    ue.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function be(t) {
        for (var e, i = 0; i < ue.length; i++)
            if (ue[i].id === t) {
                e = ue[i];
                break;
            }
        return e;
    }
    function Ee(t) {
        return (
            "*" === t
                ? (t = Object.keys(he))
                : "string" == typeof t
                  ? (t = [t])
                  : t.constructor === fe
                    ? (t = [t.prototype.type])
                    : Array.isArray(t) &&
                      t[0].constructor === fe &&
                      (t = t.map(function (t) {
                          return t.type;
                      })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function Le(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                  ? (t = [])
                  : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + pe + '="' + e + '"]');
            null !== i && ye(i.getAttribute(me), i);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + pe + '="' + e + '"]');
            "object" == typeof we(i)[0] &&
                we(i).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e = t.detail.sectionId,
                i = t.target.querySelector("[" + pe + '="' + e + '"]');
            "object" == typeof we(i)[0] &&
                we(i).forEach(function (t) {
                    var e = ue
                        .map(function (t) {
                            return t.id;
                        })
                        .indexOf(t.id);
                    ue.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = be(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = be(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = be(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = be(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const Se = "data-aos",
        ke = (t) => {
            t.querySelectorAll(`[${Se}]`).forEach((t) => {
                t.removeAttribute(Se);
            });
        },
        qe = "[data-custom-scrollbar-items]",
        Ae = "[data-custom-scrollbar]",
        Ce = "[data-custom-scrollbar-track]";
    let Te = class {
        events() {
            this.itemsParent.addEventListener("scroll", this.calcPositionEvent),
                document.addEventListener("theme:resize:width", this.calcTrackEvent);
        }
        calculateTrackWidth() {
            (this.trackWidth = 100 / this.itemsParent.children.length),
                (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
        }
        calculatePosition() {
            const t = this.scrollbar.clientWidth * ((100 - this.trackWidth) / 100);
            let e = this.itemsParent.scrollLeft / (this.itemsParent.scrollWidth - this.itemsParent.clientWidth);
            (e *= t), this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`);
        }
        destroy() {
            this.itemsParent.removeEventListener("scroll", this.calcPositionEvent),
                document.removeEventListener("theme:resize:width", this.calcTrackEvent);
        }
        constructor(t) {
            (this.itemsParent = t.querySelector(qe)),
                (this.scrollbar = t.querySelector(Ae)),
                (this.scrollbarTrack = t.querySelector(Ce)),
                (this.trackWidth = 0),
                (this.calcPositionEvent = window.theme.throttle(() => this.calculatePosition(), 50)),
                (this.calcTrackEvent = () => this.calculateTrackWidth()),
                this.scrollbar && this.itemsParent && (this.events(), this.calculateTrackWidth());
        }
    };
    const xe = {
            productSlideshow: "[data-product-slideshow]",
            productImage: "[data-product-single-media-wrapper]",
            productThumbs: "[data-product-single-media-thumbs]",
            productThumbsVertical: "[data-product-single-media-thumbs-vertical]",
            productThumb: "[data-thumbnail]",
            productThumbLink: "[data-thumbnail-id]",
            deferredMediaButton: "[data-deferred-media-button]",
            mediaType: "data-type",
            id: "data-id",
            tabIndex: "tabindex",
            arrows: "data-arrows",
            dots: "data-dots",
            navSelected: ".is-nav-selected",
            scrollable: "[data-custom-scrollbar-items]",
        },
        Ie = "flickity-enabled",
        Me = "media--hidden",
        He = "is-focused",
        Pe = "product__images__slider-nav--arrows",
        Fe = "is-moving",
        Be = "is-nav-selected",
        De = "data-thumbnail";
    let We = class {
        init() {
            this.createSlider(),
                this.createSliderNav(),
                this.createScrollable(),
                this.container.addEventListener("theme:media:select", this.selectMediaEvent),
                document.addEventListener("theme:resize:width", this.resizeEvent);
        }
        resizeEvents() {
            this.initSliderNavVertical(), this.checkThumbsWidth(), this.createScrollable();
        }
        createSlider() {
            if (!this.slideshow) return;
            const t = this,
                e = this.slideshow.querySelectorAll(`[${xe.mediaType}]`)[0],
                s = "true" === this.slideshow.getAttribute(xe.arrows),
                o = "true" === this.slideshow.getAttribute(xe.dots),
                n = {
                    autoPlay: !1,
                    arrowShape: theme.icons.arrowNavSlider,
                    prevNextButtons: s,
                    contain: !0,
                    pageDots: o,
                    adaptiveHeight: !0,
                    wrapAround: !0,
                };
            if (((this.flkty = new i(this.slideshow, n)), e)) {
                const t = e.getAttribute(xe.mediaType);
                ("model" !== t && "video" !== t && "external_video" !== t) ||
                    ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
            }
            this.flkty.on("dragStart", function () {
                t.slideshow.classList.add(Fe);
            }),
                this.flkty.on("change", function (e) {
                    const i = this.cells[e].element,
                        s = this.selectedElement,
                        o = theme.isMobile();
                    if (
                        (i.dispatchEvent(new CustomEvent("theme:media:hidden")),
                        s.classList.remove(Me),
                        t.thumbsVertical && !o)
                    ) {
                        const i = t.thumbsVertical.querySelector(xe.navSelected),
                            s = t.thumbsVertical.querySelector(`[${De}="${e}"]`);
                        i && i.classList.remove(Be), s && s.classList.add(Be), t.scrollToThumb();
                    }
                }),
                this.flkty.on("settle", function () {
                    const e = this.selectedElement,
                        i = e.getAttribute(xe.mediaType);
                    "model" === i || "video" === i || "external_video" === i
                        ? ((t.flkty.options.draggable = !1), t.flkty.updateDraggable())
                        : ((t.flkty.options.draggable = !0), t.flkty.updateDraggable()),
                        t.switchMedia(e),
                        t.slideshow.classList.remove(Fe);
                });
        }
        createSliderNav() {
            const t = this.thumbs || this.thumbsVertical;
            t &&
                this.slideshow &&
                (this.thumbsVertical
                    ? this.initSliderNavVertical()
                    : (this.flktyNav = new i(t, this.flickityOptionsNav)),
                this.checkThumbsWidth(),
                t.querySelectorAll(xe.productThumbLink).forEach((t, e) => {
                    const i = t.closest(xe.productThumb);
                    this.thumbsVertical && i && 0 === e && i.classList.add(Be),
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                            const e = theme.isMobile();
                            this.thumbsVertical &&
                                i &&
                                !e &&
                                null !== this.flkty &&
                                this.flkty.selectCell(parseInt(i.getAttribute(De)));
                        });
                }));
        }
        initSliderNavVertical() {
            if (!this.thumbsVertical || !this.slideshow) return;
            const t = theme.isMobile();
            t && !this.flktyNav
                ? (this.flktyNav = new i(this.thumbsVertical, this.flickityOptionsNav))
                : !t && this.flktyNav && (this.flktyNav.destroy(), (this.flktyNav = null));
        }
        scrollToThumb() {
            const t = this.thumbsVertical;
            if (t) {
                const e = t.querySelector(xe.navSelected);
                if (!e) return;
                const i = t.scrollTop,
                    s = t.scrollLeft,
                    o = t.offsetWidth,
                    n = t.offsetHeight,
                    r = i + n,
                    a = s + o,
                    c = e.offsetTop,
                    l = e.offsetLeft,
                    d = e.offsetWidth,
                    h = e.offsetHeight,
                    u = i > c,
                    p = s > l,
                    m = l + d > a,
                    v = c + h > r || u,
                    f = m || p,
                    g = theme.isMobile();
                if (v || f) {
                    let e = c - n + h,
                        i = l - o + d;
                    u && (e = c),
                        m && g && (i += parseInt(window.getComputedStyle(t).paddingRight)),
                        p && ((i = l), g && (i -= parseInt(window.getComputedStyle(t).paddingLeft))),
                        t.scrollTo({ top: e, left: i, behavior: "smooth" });
                }
            }
        }
        checkThumbsWidth() {
            if (this.thumbs || (this.thumbsVertical && theme.isMobile())) {
                const t = this.thumbs || this.thumbsVertical,
                    e = t.querySelectorAll(xe.productThumb),
                    i = 2 * parseInt(window.getComputedStyle(t).paddingLeft.replace("px", "")),
                    s = t.offsetWidth - i;
                let o = 0;
                e.forEach((t) => {
                    o += t.offsetWidth;
                }),
                    s < o ? t.classList.add(Pe) : t.classList.remove(Pe),
                    null !== this.flktyNav && "object" == typeof this.flktyNav && this.flktyNav.resize();
            }
        }
        createScrollable() {
            this.scrollable &&
                (theme.isMobile()
                    ? (this.customScrollbar = new Te(this.container))
                    : this.customScrollbar && this.customScrollbar.destroy());
        }
        switchMedia(t) {
            const e = Array.prototype.filter.call(t.parentNode.children, function (e) {
                return e !== t;
            });
            document.body.classList.contains(He) && t.dispatchEvent(new Event("focus")),
                e.length &&
                    e.forEach((t) => {
                        t.classList.add(Me), t.dispatchEvent(new CustomEvent("theme:media:hidden"));
                    }),
                t.classList.remove(Me),
                t.dispatchEvent(new CustomEvent("theme:media:visible"));
            const i = t.querySelector("deferred-media");
            i &&
                !0 !== i.getAttribute("loaded") &&
                t.querySelector(xe.deferredMediaButton).dispatchEvent(new Event("click", { bubbles: !1 }));
        }
        showMediaOnVariantSelect(t) {
            const e = t.detail.id,
                i = this.container.querySelector(`[data-media-id="${e}"]`);
            if (i) {
                const t = this.container.querySelector(xe.productSlideshow);
                if (t && t.classList.contains(Ie)) {
                    var s;
                    const t = Array.from(i.parentElement.children).indexOf(i);
                    null === (s = this.flkty) || void 0 === s || s.select(t);
                }
                if (this.scrollable)
                    if (window.innerWidth >= theme.sizes.small) {
                        const t = 60;
                        window.scrollTo({
                            top: i.getBoundingClientRect().top + window.scrollY - t,
                            left: 0,
                            behavior: "smooth",
                        });
                    } else {
                        const t = this.container.querySelector(xe.productImagesScroller);
                        if (!t) return;
                        t.scrollTo({ top: 0, left: i.getBoundingClientRect().left + t.scrollLeft, behavior: "smooth" });
                    }
            }
        }
        unload() {
            document.removeEventListener("theme:resize:width", this.resizeEvent);
        }
        constructor(t) {
            (this.container = t.container),
                (this.scrollable = this.container.querySelector(xe.scrollable)),
                (this.slideshow = this.container.querySelector(xe.productSlideshow)),
                (this.productImages = this.container.querySelectorAll(xe.productImage)),
                (this.thumbs = this.container.querySelector(xe.productThumbs)),
                (this.thumbsVertical = this.container.querySelector(xe.productThumbsVertical)),
                (this.flkty = null),
                (this.flktyNav = null),
                (this.flickityOptionsNav = null),
                (this.resizeEvent = () => this.resizeEvents()),
                (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t)),
                this.slideshow &&
                    (this.flickityOptionsNav = {
                        asNavFor: this.slideshow,
                        pageDots: !1,
                        prevNextButtons: !0,
                        arrowShape: theme.icons.arrowNavSlider,
                        groupCells: !0,
                        contain: !0,
                    }),
                this.productImages.length > 1 && this.init();
        }
    };
    const _e = {};
    function Oe(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return _e[t.url]
                ? _e[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange =
                                            function () {
                                                o ||
                                                (this.readyState &&
                                                    "loaded" != this.readyState &&
                                                    "complete" != this.readyState)
                                                    ? i()
                                                    : ((o = !0), e());
                                            }),
                                        s.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (_e[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return _e[t.json]
                ? Promise.resolve(_e[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((_e[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return _e[e]
                ? _e[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (_e[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    const Ne = ".pswp",
        $e = ".pswp__custom-close",
        Re = "iframe, video",
        Ve = ".pswp__thumbs",
        Ue = "data-pswp-option-classes",
        ze = "is-current",
        je = "pswp--custom-loader",
        Qe = "pswp--custom-opening",
        Xe = "pswp__loader",
        Ke = `<div class="${Xe}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    let Ye = class {
        init() {
            this.pswpElement.classList.add(Qe),
                this.initLoader(),
                Oe({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(je) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(Ue, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = Ke), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(Ue, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(je) && this.pswpElement.classList.remove(je),
                this.pswpElement.classList.remove(Qe),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.init(),
                this.a11y.trapFocus(this.pswpElement),
                this.thumbsActions(),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closeButtonClick),
                this.popup.listen("close", () => this.onClose());
        }
        closeButtonClickEvent() {
            this.popup.close(), this.a11y.removeTrapFocus(), null !== theme.a11yTrigger && theme.a11yTrigger.focus();
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${Ve} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault(),
                            t.parentElement.querySelector(`.${ze}`).classList.remove(ze),
                            t.classList.add(ze),
                            this.popup.goTo(e);
                    });
                }),
                this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
                this.popup.listen("beforeChange", () => this.setCurrentThumb()));
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(Re);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; )
                    this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(Ue, "");
            const e = this.pswpElement.querySelector(`.${Xe}`);
            e && this.pswpElement.removeChild(e),
                this.a11y.removeTrapFocus(),
                null !== theme.a11yTrigger && theme.a11yTrigger.focus(),
                this.closeBtn.removeEventListener("click", this.closeButtonClick);
        }
        setCurrentThumb() {
            const t = this.pswpElement.querySelector(`${Ve} > .${ze}`);
            if ((t && t.classList.remove(ze), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(ze), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
            }
        }
        constructor(t, e = "") {
            (this.a11y = S),
                (this.items = t),
                (this.pswpElement = document.querySelectorAll(Ne)[0]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(Ve)),
                (this.closeBtn = this.pswpElement.querySelector($e)),
                (this.closeButtonClick = () => this.closeButtonClickEvent());
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }), this.init();
        }
    };
    const Ge = "[data-product-slideshow]",
        Je = "[data-zoom-wrapper]",
        Ze = "data-image-width",
        ti = "data-image-height",
        ei = "data-lightbox",
        ii = "pswp-zoom-gallery",
        si = "pswp-zoom-gallery--single",
        oi = "is-moving";
    let ni = class {
        init() {
            this.zoomWrappers.length &&
                this.zoomWrappers.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault();
                        const s = this.slideshow && this.slideshow.classList.contains(oi);
                        (theme.a11yTrigger = t), s || this.createZoom(e);
                    }),
                        t.addEventListener("keyup", (e) => {
                            "Enter" === e.code && (e.preventDefault(), t.dispatchEvent(new Event("click")));
                        });
                });
        }
        createZoom(t) {
            const e = this;
            let i = [],
                s = 0;
            this.zoomWrappers.forEach((o) => {
                const n = o.getAttribute("href"),
                    r = parseInt(o.getAttribute(Ze)),
                    a = parseInt(o.getAttribute(ti));
                if ((i.push({ src: n, w: r, h: a, msrc: n }), (s += 1), e.zoomWrappers.length === s)) {
                    let e = `${ii}`;
                    1 === s && (e = `${ii} ${si}`);
                    new Ye(i, {
                        barsSize: { top: 0, bottom: "auto" },
                        history: !1,
                        focus: !1,
                        index: t,
                        mainClass: e,
                        showHideOpacity: !0,
                        showAnimationDuration: 250,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !1,
                        closeEl: !0,
                        closeElClasses: ["caption-close"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                    });
                }
            });
        }
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(Ge)),
                (this.zoomWrappers = this.container.querySelectorAll(Je)),
                (this.zoomEnable = "true" === this.container.getAttribute(ei)),
                this.zoomEnable && this.init();
        }
    };
    const ri = "html5",
        ai = "youtube",
        ci = "[data-deferred-media]",
        li = "[data-deferred-media-button]",
        di = "[data-product-single-media-wrapper]",
        hi = "[data-video]",
        ui = "data-media-id",
        pi = "media--hidden";
    theme.mediaInstances = {};
    let mi = class {
        init() {
            this.container.querySelectorAll(hi).forEach((t) => {
                const e = t.querySelector(li);
                e && e.addEventListener("click", this.loadContent.bind(this, t));
            });
        }
        loadContent(t) {
            if (t.querySelector(ci).getAttribute("loaded")) return;
            const e = document.createElement("div");
            e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                o = this.hostFromVideoElement(s),
                n = t.querySelector(ci);
            n.appendChild(s).focus(),
                n.setAttribute("loaded", !0),
                (this.players[i] = {
                    mediaId: i,
                    sectionId: this.id,
                    container: t,
                    element: s,
                    host: o,
                    ready: () => {
                        this.createPlayer(i);
                    },
                });
            const r = this.players[i];
            switch (r.host) {
                case ri:
                    this.loadVideo(r, ri);
                    break;
                case ai:
                    window.isYoutubeAPILoaded
                        ? this.loadVideo(r, ai)
                        : Oe({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(r, ai));
            }
        }
        hostFromVideoElement(t) {
            return "VIDEO" === t.tagName
                ? ri
                : "IFRAME" === t.tagName &&
                    /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)
                  ? ai
                  : null;
        }
        loadVideo(t, e) {
            t.host === e && t.ready();
        }
        createPlayer(t) {
            const e = this.players[t],
                i = e.container.dataset.enableVideoLooping;
            switch (e.host) {
                case ri:
                    e.element.play(),
                        e.element.addEventListener("play", () => {
                            this.pauseOtherMedia(t);
                        }),
                        e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)),
                        e.container.addEventListener("theme:xr-launch", (t) => this.onHidden(t)),
                        e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)),
                        this.observeVideo(e);
                    break;
                case ai:
                    if (e.host == ai && e.player) return;
                    YT.ready(() => {
                        const s = e.container.dataset.videoId;
                        (this.players[t].player = new YT.Player(e.element, {
                            videoId: s,
                            events: {
                                onReady: (t) => {
                                    t.target.playVideo();
                                },
                                onStateChange: (e) => {
                                    0 === e.data && i && e.target.seekTo(0),
                                        1 === e.data && this.pauseOtherMedia(t),
                                        e.data;
                                },
                            },
                        })),
                            (window.isYoutubeAPILoaded = !0),
                            e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)),
                            e.container.addEventListener("theme:xr-launch", (t) => this.onHidden(t)),
                            e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)),
                            this.observeVideo(e);
                    });
            }
        }
        observeVideo(t) {
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        1 != e.intersectionRatio ? this.pauseVideo(t) : this.playVideo(t);
                    });
                },
                { threshold: 1 }
            ).observe(t.element);
        }
        playVideo(t) {
            t.player && t.player.playVideo ? t.player.playVideo() : t.element && t.element.play && t.element.play();
        }
        pauseVideo(t) {
            t.player && t.player.pauseVideo ? t.player.pauseVideo() : t.element && t.element.pause && t.element.pause();
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i);
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.playVideo(i);
            }
        }
        pauseOtherMedia(t) {
            const e = `[${ui}="${t}"]`,
                i = document.querySelector(`${di}${e}`),
                s = document.querySelectorAll(`${di}:not(${e})`);
            i.classList.remove(pi),
                s.length &&
                    s.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden")), t.classList.add(pi);
                    });
        }
        constructor(t) {
            (this.section = t), (this.container = t.container), (this.id = t.id), (this.players = {}), this.init();
        }
    };
    theme.mediaInstances = {};
    let vi = class {
        init() {
            new mi(this.section), new ni(this.section), new We(this.section);
        }
        constructor(t) {
            (this.section = t), (this.id = t.id), (this.container = t.container);
        }
    };
    const fi = "[data-api-content]",
        gi = "[data-section-id]",
        yi = "[data-collection-slider]",
        wi = "[data-collection-slider-wrapper]",
        bi = "[data-quickview-wrap]",
        Ei = "data-quickview-id",
        Li = "[data-quickview-close]",
        Si = "[data-quickview-container]",
        ki = "[data-collection-featured-block]",
        qi = "[data-product-block]",
        Ai = "data-trigger-quickview",
        Ci = "[data-product-slideshow]",
        Ti = "data-video-looping",
        xi = "is-loading",
        Ii = "is-loaded",
        Mi = "is-visible",
        Hi = "is-quickview-open",
        Pi = "is-focused",
        Fi = "flickity-enabled";
    let Bi = class {
        init() {
            this.initButton(), this.initFetch();
        }
        initFetch() {
            this.productBlock.addEventListener(
                "theme:quickview:open",
                () => {
                    this.renderProduct();
                },
                !1
            );
        }
        renderProduct() {
            fetch(`${theme.routes.root}products/${this.handle}?section_id=api-quickview`)
                .then((t) => t.text())
                .then((t) => {
                    const e = document.createElement("div");
                    e.innerHTML = t.replaceAll("||product-handle||", this.handle);
                    const i = e.querySelector(bi).dataset.quickviewId;
                    this.layoutCarousel && this.collectionSliderWrapper
                        ? this.collectionSliderWrapper.insertAdjacentHTML("beforeend", e.querySelector(fi).innerHTML)
                        : this.productBlock.insertAdjacentHTML("beforeend", e.querySelector(fi).innerHTML),
                        this.productBlock.classList.add(Ii),
                        (this.quickviewWrap = this.container.querySelector(`[${Ei}="${i}"]`)),
                        (this.quickviewClose = this.quickviewWrap.querySelector(Li)),
                        (this.quickviewWrapHeight = this.quickviewWrap.querySelector(Si).offsetHeight),
                        (this.quickview = this.quickviewWrap.parentNode),
                        this.onLoaded(),
                        this.show();
                        
                })
                .catch(function (t) {
                    console.log("error: ", t);
                });
        }
        initButton() {
            const t = this.productBlock.querySelectorAll(`[${Ai}='${this.handle}']`);
            t.length &&
                t.forEach((t) => {
                    t.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = this.productBlock.classList.contains(Ii),
                            i = this.productBlock.classList.contains(Hi),
                            s = null !== this.productBlock.parentNode.querySelector(`.${Hi}`),
                            o = new CustomEvent("theme:quickview:open", { handle: this.handle });
                        this.isQuickViewLoading ||
                            ((this.isQuickViewLoading = !0),
                            e && i
                                ? this.hide()
                                : !e || i || s
                                  ? e && !i && s
                                      ? (this.hide(),
                                        setTimeout(() => {
                                            this.show();
                                        }, 200))
                                      : s
                                        ? (this.hide(),
                                          setTimeout(() => {
                                              this.productBlock.dispatchEvent(o);
                                          }, 200))
                                        : this.productBlock.dispatchEvent(o)
                                  : this.show());
                    });
                });
        }
        show() {
            var t;
            const e = (window.innerHeight - this.quickviewWrapHeight) / 2,
                i =
                    this.quickviewWrap.getBoundingClientRect().top +
                    window.scrollY -
                    e -
                    theme.dimensions.headerScrolled,
                s = null === (t = document.querySelector(ki)) || void 0 === t ? void 0 : t.offsetHeight,
                o = document.body.classList.contains(Pi);
            document.documentElement.style.setProperty("--collection-featured-block-height", `${s}px`),
                this.quickview.classList.remove(xi),
                window.scrollTo({ top: i, left: 0, behavior: "smooth" }),
                this.productBlock.classList.add(Hi),
                this.quickview.classList.add(Mi),
                (this.isQuickViewLoading = !1),
                o && this.a11y.trapFocus(this.quickviewWrap, { elementToFocus: this.quickviewClose });
        }
        hide() {
            const t = this.productBlock.parentNode.querySelectorAll(qi),
                e = document.body.classList.contains(Pi);
            if (
                (t.forEach((t) => {
                    if (t.classList.contains(Hi)) {
                        const e = t.querySelector(".quickView");
                        e &&
                            (e.classList.remove(Mi, xi),
                            e.addEventListener("transitionend", () => {
                                e.remove(), t.classList.remove(Ii, Hi);
                            }));
                    }
                }),
                (this.isQuickViewLoading = !1),
                this.a11y.removeTrapFocus(),
                e)
            ) {
                const t = document.querySelector(`[${Ai}="${this.handle}"]`);
                setTimeout(() => {
                    document.documentElement.style.setProperty("--collection-featured-block-height", "none"), t.focus();
                }, 300);
            }
        }
        onLoaded() {
            const t = `${this.id}-${this.quickviewWrap.getAttribute(Ei)}`,
                e = this.quickviewWrap.querySelector(Ci).classList.contains(Fi),
                i = { id: t, container: this.quickviewWrap, type: "quickview" };
            theme.settings.enableVideoLooping && this.quickviewWrap.setAttribute(Ti, !0),
                e
                    ? window.dispatchEvent(new Event("resize"))
                    : void 0 === theme.mediaInstances[this.id]
                      ? ((theme.mediaInstances[t] = new vi(i)), theme.mediaInstances[t].init())
                      : theme.mediaInstances[t].initSlider(),
                this.quickviewClose.addEventListener("click", (t) => {
                    t.preventDefault(), this.hide();
                }),
                document.addEventListener("keyup", (t) => {
                    "Escape" === t.code && document.querySelectorAll(`${qi}.${Mi}`).length && this.hide();
                });
            const s = new CustomEvent("theme:quickview:loaded", { bubbles: !0 });
            this.productBlock.dispatchEvent(s), this.initPaymentButton();
        }
        initPaymentButton() {
            const t = theme.settings.enablePaymentButton,
                e = theme.settings.enableAcceptTerms;
            t &&
                !e &&
                "undefined" != typeof Shopify &&
                void 0 !== Shopify.PaymentButton &&
                void 0 !== Shopify.PaymentButton.init &&
                Shopify.PaymentButton.init();
        }
        constructor(t, e) {
            (this.button = t),
                (this.id = e),
                (this.container = this.button.closest(gi)),
                (this.collectionSliderWrapper = this.container.querySelector(wi)),
                (this.layoutCarousel = this.container.querySelector(yi)),
                (this.handle = this.button.getAttribute(Ai)),
                (this.productBlock = this.button.closest(qi)),
                (this.quickview = null),
                (this.quickviewWrap = null),
                (this.quickviewClose = null),
                (this.quickviewWrapHeight = 0),
                (this.isQuickViewLoading = !1),
                (this.a11y = S),
                (this.swatches = []),
                this.init();
        }
    };
    const Di = "[data-trigger-quickview]",
        Wi = "is-init";
    let _i = {},
        Oi = class {
            init() {
                _i[this.id] = [];
                const t = this.container.querySelectorAll(Di);
                t.length &&
                    t.forEach((t) => {
                        // t.classList.contains(Wi) || (_i[this.id].push(new Bi(t, this.id)), t.classList.add(Wi));
                        if (!t.classList.contains(Wi)) {
                            _i[this.id].push(new Bi(t, this.id));
                            t.classList.add(Wi);
                        }

                    });
            }
            constructor(t) {
                (this.container = t),
                    (this.id = this.container.dataset.sectionId),
                    theme.settings.showQuickView && this.init();
            }
        };
        document.addEventListener("shopify:section:load", (e) => new Oi(e.target));

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.nodeType !== 1) return;

            // If a product block was added
            if (node.matches && node.matches("[data-product-block]")) {
                const section = node.closest("[data-section-id]");
                if (section) new Oi(section);
            }

            // If products are added inside a wrapper
            const products = node.querySelectorAll?.("[data-product-block]");
            if (products && products.length) {
                const section = node.closest("[data-section-id]");
                if (section) new Oi(section);
            }
        });
    });
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

    const Ni = {
            onLoad() {
                this.section = new Oi(this.container);
            },
        },
        $i = "[data-infinity]",
        Ri = "[data-pagination]",
        Vi = "data-section-id";
    let Ui = {},
        zi = class {
            init() {
                const t = this.container.getAttribute(Vi);
                this.fix(),
                    (this.endlessScroll = new e({
                        container: `section[${Vi}="${t}"] ${$i}`,
                        pagination: `section[${Vi}="${t}"] ${Ri}`,
                        callback: () => {
                            new Oi(this.container);
                        },
                    }));
            }
            fix() {
                e.prototype.loadMore = function () {
                    (this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML) return;
                            if (4 === !this.request.readyState || 200 === !this.request.status) return;
                            const t = this.request.responseXML.querySelector(this.settings.container),
                                e = this.request.responseXML.querySelector(this.settings.pagination);
                            this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML),
                                      this.settings.callback &&
                                          "function" == typeof this.settings.callback &&
                                          this.settings.callback(this.request.responseXML),
                                      this.initialize());
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send();
                };
            }
            unload() {
                this.endlessScroll && this.endlessScroll.destroy();
            }
            constructor(t) {
                (this.container = t),
                    (this.infinityContainer = this.container.querySelector($i)),
                    (this.endlessScroll = null),
                    this.infinityContainer && this.init();
            }
        };
    const ji = {
            onLoad() {
                Ui = new zi(this.container);
            },
            onUnload: function () {
                "function" == typeof Ui.unload && Ui.unload();
            },
        },
        Qi = {};
    let Xi = class {
        init() {
            this.checkWindowWidth(), document.addEventListener("theme:resize", this.checkWidthOnResize);
        }
        checkWindowWidth() {
            window.innerWidth < theme.sizes.small && ke(this.container);
        }
        onUnload() {
            document.removeEventListener("theme:resize", this.checkWidthOnResize);
        }
        constructor(t) {
            (this.container = t.container), (this.checkWidthOnResize = this.checkWindowWidth()), this.init();
        }
    };
    const Ki = {
        onLoad() {
            Qi[this.id] = new Xi(this);
        },
        onUnload(t) {
            Qi[this.id].onUnload(t);
        },
    };
    ge("blog", [Ki, ji]), ge("featured-blog", Ki);
    const Yi = "[data-range-slider]",
        Gi = "[data-range-left]",
        Ji = "[data-range-right]",
        Zi = "[data-range-line]",
        ts = "[data-range-holder]",
        es = "data-se-min",
        is = "data-se-max",
        ss = "data-se-min-value",
        os = "data-se-max-value",
        ns = "data-se-step",
        rs = "data-range-filter-update",
        as = "[data-field-price-min]",
        cs = "[data-field-price-max]",
        ls = "is-initialized";
    let ds = class {
        init() {
            let t = this.min;
            this.slider.hasAttribute(ss) && (t = parseFloat(this.slider.getAttribute(ss)));
            let e = this.max;
            this.slider.hasAttribute(os) && (e = parseFloat(this.slider.getAttribute(os))),
                t < this.min && (t = this.min),
                e > this.max && (e = this.max),
                t > e && (t = e),
                this.slider.getAttribute(ns) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(ns)))),
                this.reset(),
                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(t),
                this.setMaxValue(e),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.slider.classList.add(ls);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchLeft.style.left =
                Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(ss, t);
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchRight.style.left =
                Math.ceil(
                    e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) +
                        this.normalizeFact
                ) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(os, t);
        }
        onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]),
                t.currentTarget === this.touchLeft
                    ? (this.x = this.touchLeft.offsetLeft)
                    : (this.x = this.touchRight.offsetLeft),
                (this.startX = e.pageX - this.x),
                (this.selectedTouch = t.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
        }
        onMove(t) {
            let e = t;
            if (
                (t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.selectedTouch === this.touchLeft
                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                          ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10)
                          : this.x < 0 && (this.x = 0),
                      (this.selectedTouch.style.left = this.x + "px"))
                    : this.selectedTouch === this.touchRight &&
                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                          ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
                          : this.x > this.maxX && (this.x = this.maxX),
                      (this.selectedTouch.style.left = this.x + "px")),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.calculateValue(),
                this.slider.getAttribute("on-change"))
            ) {
                new Function("min, max", this.slider.getAttribute("on-change"))(
                    this.slider.getAttribute(ss),
                    this.slider.getAttribute(os)
                );
            }
            this.onChange(this.slider.getAttribute(ss), this.slider.getAttribute(os));
        }
        onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.slider.getAttribute(ss), this.slider.getAttribute(os));
        }
        onChange(t, e) {
            const i = this.slider.closest(ts);
            if (i) {
                const s = i.querySelector(as),
                    o = i.querySelector(cs);
                s && o && ((s.value = t), (o.value = e));
            }
        }
        onChanged(t, e) {
            this.slider.hasAttribute(rs) &&
                this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                i = e + t;
            if (
                ((e = e * (this.max - this.min) + this.min),
                (i = i * (this.max - this.min) + this.min),
                0 !== this.step)
            ) {
                let t = Math.floor(e / this.step);
                (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(ss, e),
                this.selectedTouch === this.touchRight && this.slider.setAttribute(os, i);
        }
        onUnload() {
            this.initFilters && document.removeEventListener("theme:resize:width", this.initFilters);
        }
        constructor(t) {
            (this.container = t.container),
                (this.slider = t.querySelector(Yi)),
                (this.initFilters = () => this.init()),
                this.slider &&
                    ((this.onMoveEvent = (t) => this.onMove(t)),
                    (this.onStopEvent = (t) => this.onStop(t)),
                    (this.onStartEvent = (t) => this.onStart(t)),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.touchLeft = this.slider.querySelector(Gi)),
                    (this.touchRight = this.slider.querySelector(Ji)),
                    (this.lineSpan = this.slider.querySelector(Zi)),
                    (this.min = parseFloat(this.slider.getAttribute(es))),
                    (this.max = parseFloat(this.slider.getAttribute(is))),
                    (this.step = 0),
                    (this.normalizeFact = 26),
                    document.addEventListener("theme:resize:width", this.initFilters),
                    document.addEventListener("theme:filter:init", this.initFilters),
                    this.init());
        }
    };
    const hs = {};
    let us = class {
        init() {
            var t;
            this.collectionSort && this.initSort(),
                this.collectionProducts && (this.collection = this.collectionProducts.getAttribute("data-collection")),
                this.filtersEnable && this.initFacetedFilters(),
                null === (t = this.showMoreOptions) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.addEventListener("click", this.showMoreEvent);
                    }),
                this.initFilterToggleButtons(),
                this.checkFiltersPosition(!0),
                document.addEventListener("theme:resize", this.resizeFiltersEvent);
        }
        initSort() {
            this.collectionSort.addEventListener("change", (t) => {
                const e = new window.URL(window.location.href),
                    i = t.currentTarget.value,
                    s = e.searchParams;
                s.set("sort_by", i),
                    (e.search = s.toString()),
                    this.collectionProducts.setAttribute("data-sort", i),
                    this.requestFilteredProducts(e.toString());
            });
        }
        initFilterToggleButtons() {
            var t;
            this.filters &&
                (null === (t = this.filters.querySelectorAll("[data-accordion-trigger]")) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.addEventListener("click", (e) => {
                            const i = t.parentNode.querySelector("[data-filter-container]").getBoundingClientRect().top;
                            document.documentElement.style.setProperty("--filters-top", `${i}px`);
                            t.parentNode.querySelector("[data-range-slider]") &&
                                !this.isRangeSliderInitialized &&
                                (this.filtersForm.dispatchEvent(new CustomEvent("theme:filter:init", { bubbles: !0 })),
                                (this.isRangeSliderInitialized = !0)),
                                document.addEventListener("click", this.documentClick);
                        });
                    }));
        }
        showMore(t) {
            t.preventDefault();
            const e = t.target.matches("[data-show-more]") ? t.target : t.target.closest("[data-show-more]");
            e.parentElement.classList.add("hidden"),
                e.parentElement.previousElementSibling.querySelectorAll("[data-link-hidden]").forEach((t, e) => {
                    t.classList.remove("hidden");
                    const i = t.querySelector("input");
                    0 === e &&
                        document.body.classList.contains("is-focused") &&
                        i &&
                        (this.collectionSidebarSlideOut || window.theme.isMobile()
                            ? (this.a11y.removeTrapFocus(),
                              this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: i }))
                            : i.focus());
                });
        }
        initFacetedFilters() {
            this.filters.hasAttribute("data-filters-available") &&
                (new ds(this.filtersForm),
                (this.filtersInputs = this.filtersForm.querySelectorAll("input, select, label, textarea")),
                this.filtersInputs.length &&
                    this.filtersInputs.forEach((t) => {
                        t.addEventListener(
                            "input",
                            window.theme.debounce(() => {
                                this.filtersForm && "function" == typeof this.filtersForm.submit && this.submitForm();
                            }, 500)
                        );
                    }),
                this.filtersForm.addEventListener("theme:filter:range-update", () => this.updateRange()),
                this.initResets());
        }
        submitForm() {
            const t = new FormData(this.filtersForm),
                e = new URLSearchParams(t);
            this.requestFilteredProducts(`${this.collection}${e.toString()}`);
        }
        initResets() {
            const t = this.container.querySelectorAll("[data-filter-reset-button]");
            (this.resetAlt = this.collectionProducts.querySelector("[data-filters-reset-button]")),
                t.length &&
                    t.forEach((t) => {
                        t.addEventListener("click", (t) => this.bindResetButton(t));
                    }),
                this.resetAlt && this.resetAlt.addEventListener("click", (t) => this.bindResetButton(t));
        }
        updateRange() {
            if (this.filtersForm && "function" == typeof this.filtersForm.submit) {
                const t = this.filtersForm.querySelector("[data-se-min-value]"),
                    e = this.filtersForm.querySelector("[data-se-max-value]"),
                    i = this.filtersForm.querySelector("[data-field-price-min]"),
                    s = this.filtersForm.querySelector("[data-field-price-max]");
                if (t && e && i && s && t.hasAttribute("data-se-min-value") && e.hasAttribute("data-se-max-value")) {
                    const o = parseInt(i.placeholder),
                        n = parseInt(s.placeholder),
                        r = parseInt(t.getAttribute("data-se-min-value")),
                        a = parseInt(e.getAttribute("data-se-max-value"));
                    (o === r && n === a) || ((i.value = r), (s.value = a), this.submitForm());
                }
            }
        }
        closeOnOutsideClick(t) {
            const e = this.filters.contains(t.target),
                i = this.filters.querySelector("details[open]");
            if (!e && i && this.isTopPosition()) {
                this.filters
                    .querySelector("details[open]")
                    .querySelector("[data-accordion-trigger]")
                    .dispatchEvent(new Event("click")),
                    document.removeEventListener("click", this.documentClick);
            }
        }
        requestFilteredProducts(t) {
            const e = parseInt(Math.ceil(this.collectionWrapper.offsetTop) - theme.dimensions.headerScrolled);
            this.collectionWrapper.classList.add("is-loading"),
                window.scrollTo({ top: e, left: 0, behavior: "smooth" }),
                history.replaceState && window.history.pushState({ path: t }, "", t),
                fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector("[data-collection-products]").innerHTML,
                            s = e.querySelector("[data-pagination]"),
                            o = e.querySelector("[data-filters]");
                        if (
                            ((this.collectionProducts.innerHTML = i),
                            this.pagination && (this.pagination.innerHTML = null !== s ? s.innerHTML : ""),
                            this.pagination ||
                                null === s ||
                                (this.collectionGridWrapper.appendChild(s),
                                (this.pagination = this.collectionGridWrapper.querySelector("[data-pagination]"))),
                            o)
                        ) {
                            const t = o.innerHTML;
                            (this.filters.innerHTML = t),
                                (this.filtersForm = this.filters.querySelector("[data-filters-form]")),
                                (this.accordionElements = this.container.querySelector("accordion-elements")),
                                this.initFacetedFilters(),
                                this.checkFiltersPosition(),
                                this.initFilterToggleButtons(),
                                this.bindSwatchFilters();
                        }
                        ji.onUnload(), new zi(this.container), new Oi(this.container);
                    })
                    .catch((t) => {
                        this.collectionWrapper.classList.remove("is-loading");
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.collectionWrapper.classList.remove("is-loading");
                        }, 450);
                    });
        }
        checkFiltersPosition(t = !1) {
            if (!this.filters) return;
            const e = this.isTopPosition() ? "top" : "left",
                i = this.filtersPositionState !== e;
            if (t || i) {
                var s, o, n;
                if (this.isTopPosition())
                    null === (s = this.accordionElements) || void 0 === s || s.setAttribute("single", !0),
                        null === (o = this.filters.querySelectorAll("details[open]")) ||
                            void 0 === o ||
                            o.forEach((t) => {
                                t.hasAttribute("open") &&
                                    (t.removeAttribute("open"),
                                    (t.querySelector("[data-filter-container]").style.height = 0));
                            });
                else null === (n = this.accordionElements) || void 0 === n || n.removeAttribute("single");
                this.filtersPositionState = e;
            }
        }
        isTopPosition() {
            var t;
            return (
                window.innerWidth < theme.sizes.widescreen ||
                (null === (t = this.filters) || void 0 === t
                    ? void 0
                    : t.classList.contains("collection__filters--top"))
            );
        }
        bindResetButton(t) {
            t.preventDefault(), this.requestFilteredProducts(t.currentTarget.href);
        }
        onUnload() {
            document.removeEventListener("theme:resize", this.resizeFiltersEvent);
        }
        bindSwatchFilters() {
            this.swatches = [];
            this.container.querySelectorAll("[data-swatch]").forEach((t) => {
                this.swatches.push(new Swatch(t));
            });
        }
        constructor(t) {
            (this.container = t.container),
                (this.collectionGridWrapper = this.container.querySelector("[data-collection-grid-wrapper]")),
                (this.collectionSort = this.container.querySelector("[data-collection-sort]")),
                (this.collectionProducts = this.container.querySelector("[data-collection-products]")),
                (this.collectionWrapper = this.container.querySelector("[data-collection-wrapper]")),
                (this.pagination = this.container.querySelector("[data-pagination]")),
                (this.accordionElements = this.container.querySelector("accordion-elements")),
                (this.filters = this.container.querySelector("[data-filters]")),
                (this.filtersEnable = "true" === this.container.getAttribute("data-filters-enable")),
                (this.filtersForm = this.container.querySelector("[data-filters-form]")),
                (this.filtersResets = this.container.querySelector("[data-filters-reset]")),
                (this.showMoreOptions = this.container.querySelectorAll("[data-show-more]")),
                (this.filtersInputs = []),
                (this.sort = null),
                (this.collection = null),
                (this.reset = null),
                (this.filtersPositionState = this.isTopPosition() ? "top" : "left"),
                (this.isRangeSliderInitialized = !1),
                (this.showMoreEvent = (t) => this.showMore(t)),
                (this.resizeFiltersEvent = () => this.checkFiltersPosition()),
                (this.documentClick = (t) => this.closeOnOutsideClick(t)),
                this.init();
        }
    };
    const ps = {
        onLoad() {
            hs[this.id] = new us(this);
        },
        onUnload(t) {
            hs[this.id].onUnload(t);
        },
    };
    ge("collection", [ps, Ni, ji]), ge("search-template", [ps, Ni, ji]);
    ge("footer", [
        {
            onLoad() {
                var t = document.querySelector("[data-powered-link] a");
                t && t.setAttribute("rel", "noopener");
            },
        },
    ]);
    const ms = "[data-faq-trigger]",
        vs = "[data-accordion-trigger]",
        fs = "data-index",
        gs = "is-active";
    let ys = class extends p {
        connectedCallback() {
            (this.triggers = this.querySelectorAll(ms)),
                this.triggers.forEach((t) => {
                    t.addEventListener("click", (e) => {
                        if (t.classList.contains(gs)) return;
                        const i = this.querySelector(`${ms}.${gs}`),
                            s = this.querySelector(`${vs}[${fs}="${t.dataset.index}"]`);
                        null == i || i.classList.remove(gs), null == s || s.click(), t.classList.add(gs);
                    });
                });
        }
        constructor() {
            super();
        }
    };
    customElements.get("faq-list") || customElements.define("faq-list", ys);
    const ws = {},
        bs = "[data-collection-slider]",
        Es = "[data-prev-arrow]",
        Ls = "[data-next-arrow]",
        Ss = "[data-product-block]",
        ks = "[data-product-image]",
        qs = "data-quickview-id",
        As = "[data-trigger-quickview]",
        Cs = "is-visible",
        Ts = "flickity-enabled",
        xs = "is-quickview-open";
    let Is = class {
        init() {
            this.slideshowPrev.addEventListener("click", this.goToPrevSlide.bind(this)),
                this.slideshowNext.addEventListener("click", this.goToNextSlide.bind(this)),
                ke(this.container),
                this.sliderInit(),
                this.productBlocks.forEach((t) => {
                    t.addEventListener("theme:quickview:loaded", () => {
                        t.classList.add(xs), this.setQuickViewPosition();
                    });
                }),
                document.addEventListener("theme:resize", this.resizeEvents);
        }
        sliderInit() {
            const t = this.slideshow.classList.contains(Ts);
            window.innerWidth >= theme.sizes.small
                ? t ||
                  (this.flkty = new i(this.slideshow, {
                      groupCells: "100%",
                      autoPlay: !1,
                      prevNextButtons: !1,
                      pageDots: !1,
                      wrapAround: !1,
                      cellAlign: "left",
                      contain: !0,
                      on: {
                          ready: () => {
                              this.setArrowPosition();
                          },
                          change: function () {
                              const t = this.element.querySelector(`${Ss}.${Cs}`);
                              null !== t && t.querySelector(As).dispatchEvent(new Event("click"));
                          },
                      },
                  }))
                : t && this.flkty.destroy();
        }
        goToPrevSlide(t) {
            t.preventDefault(), this.flkty.previous(!0);
        }
        goToNextSlide(t) {
            t.preventDefault(), this.flkty.next(!0);
        }
        setArrowPosition() {
            const t = this.slideshow.querySelector(ks);
            if (!t) return;
            let e = t.offsetHeight / 2;
            (e -= this.slideshowPrev.offsetHeight / 2),
                (this.slideshowPrev.style.top = `${e}px`),
                (this.slideshowNext.style.top = `${e}px`);
        }
        setQuickViewPosition() {
            const t = this.slideshow.querySelector(`.${xs}`);
            if (null === t) return;
            const e = t.dataset.quickviewElement,
                i = this.container.querySelector(`[${qs}="${e}"]`),
                s = parseInt(window.getComputedStyle(this.slideshow).paddingLeft.replace("px", "")),
                o = this.slideshow.offsetWidth - 2 * s;
            if (i) {
                let e = t.offsetLeft;
                e >= o && (e %= o), (i.style.left = `calc(${t.style.left} - ${e}px)`), (i.style.width = "100%");
            }
        }
        onUnload() {
            if (this.slideshow) {
                this.slideshow.classList.contains(Ts) && this.flkty.destroy();
            }
            document.removeEventListener("theme:resize", this.resizeEvents);
        }
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(bs)),
                (this.productBlocks = this.container.querySelectorAll(Ss)),
                (this.productImages = this.container.querySelectorAll(ks)),
                (this.slideshowPrev = this.container.querySelector(Es)),
                (this.slideshowNext = this.container.querySelector(Ls)),
                (this.flkty = null),
                (this.resizeEvents = () => {
                    this.sliderInit(), this.setArrowPosition(), this.setQuickViewPosition();
                }),
                this.slideshow && this.productBlocks.length && this.init();
        }
    };
    ge("featured-collection", [
        {
            onLoad() {
                ws[this.id] = new Is(this);
            },
            onUnload(t) {
                ws[this.id].onUnload(t);
            },
        },
        Ni,
    ]);
    const Ms = {},
        Hs = "[data-gallery-slider]",
        Ps = "[data-slider]",
        Fs = "[data-prev-arrow]",
        Bs = "[data-next-arrow]",
        Ds = "data-options",
        Ws = "data-slide",
        _s = "data-slide-index",
        Os = "gallery-slider--is-loading",
        Ns = "flickity-enabled";
    let $s = class {
        init() {
            let t = JSON.parse(this.options.replace(/'/g, '"'));
            (t = { ...t, on: { ready: () => this.slider.classList.remove(Os) } }),
                (this.flkty = new o(this.slideshow, t)),
                this.slideshowPrev && this.slideshowPrev.addEventListener("click", () => this.flkty.previous(!0)),
                this.slideshowNext && this.slideshowNext.addEventListener("click", () => this.flkty.next(!0)),
                document.addEventListener("theme:scroll", this.checkSliderVisibilityOnScrollEvent);
        }
        isAutoplay() {
            return !1 !== this.flkty.options.autoPlay;
        }
        checkSliderVisibility() {
            if (!this.flkty) return;
            const t = this.slideshow.classList.contains(Ns);
            (visibilityHelper.isElementPartiallyVisible(this.slideshow) ||
                visibilityHelper.isElementTotallyVisible(this.slideshow)) &&
            t &&
            this.isAutoplay()
                ? this.flkty.playPlayer()
                : this.flkty.stopPlayer();
        }
        onUnload() {
            this.flkty.destroy(), document.removeEventListener("theme:scroll", this.checkSliderVisibilityOnScrollEvent);
        }
        onBlockSelect(t) {
            const e = this.slideshow.querySelector(`[${Ws}="${t.detail.blockId}"]`),
                i = parseInt(e.getAttribute(_s));
            this.flkty.select(i), this.flkty.stopPlayer();
        }
        onBlockDeselect() {
            this.isAutoplay() && this.flkty.playPlayer();
        }
        constructor(t) {
            (this.container = t.container),
                (this.slider = this.container.querySelector(Hs)),
                (this.slideshow = this.container.querySelector(Ps)),
                (this.options = this.slideshow.getAttribute(Ds)),
                (this.slideshowPrev = this.container.querySelector(Fs)),
                (this.slideshowNext = this.container.querySelector(Bs)),
                (this.checkSliderVisibilityOnScrollEvent = this.checkSliderVisibility()),
                (this.flkty = null),
                this.init();
        }
    };
    ge("gallery", [
        {
            onLoad() {
                Ms[this.id] = new $s(this);
            },
            onUnload(t) {
                Ms[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                Ms[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                Ms[this.id].onBlockDeselect(t);
            },
        },
    ]),
        ge("collection-grid", [ji]);
    const Rs = {},
        Vs = "[data-logo-list-slider]",
        Us = "[data-logo-list-slide]",
        zs = "data-logo-list-slide",
        js = "data-slide-index",
        Qs = "flickity-enabled";
    let Xs = class {
        init() {
            this.sliderInit(), document.addEventListener("theme:resize", this.sliderInitEvent);
        }
        sliderInit() {
            const t = this.slideshow.querySelectorAll(Us).length,
                e = document.documentElement.clientWidth || document.body.clientWidth,
                s = 220 * t,
                o = this.slideshow.classList.contains(Qs);
            e < s
                ? o ||
                  (this.flkty = new i(this.slideshow, {
                      autoPlay: 4e3,
                      prevNextButtons: !1,
                      pageDots: !1,
                      wrapAround: !0,
                  }))
                : o && this.flkty.destroy();
        }
        onUnload() {
            this.slideshow.classList.contains(Qs) && this.flkty.destroy(),
                document.removeEventListener("theme:resize", this.sliderInitEvent);
        }
        onBlockSelect(t) {
            const e = this.slideshow.querySelector(`[${zs}="${t.detail.blockId}"]`),
                i = parseInt(e.getAttribute(js));
            this.slideshow.classList.contains(Qs) && (this.flkty.select(i), this.flkty.pausePlayer());
        }
        onBlockDeselect() {
            this.slideshow.classList.contains(Qs) && this.flkty.unpausePlayer();
        }
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(Vs)),
                (this.sliderInitEvent = () => this.sliderInit()),
                this.init();
        }
    };
    ge("logo-list", {
        onLoad() {
            Rs[this.id] = new Xs(this);
        },
        onUnload(t) {
            Rs[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Rs[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            Rs[this.id].onBlockDeselect();
        },
    });
    const Ks = "[data-video-play]",
        Ys = "data-video-play";
    let Gs = class {
        constructor(t, e = Ks, i = Ys) {
            (this.container = t),
                (this.videoPlay = this.container.querySelectorAll(e)),
                this.videoPlay.length &&
                    this.videoPlay.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            const e = t.currentTarget;
                            if (e.hasAttribute(i) && "" !== e.getAttribute(i).trim()) {
                                t.preventDefault(), (theme.a11yTrigger = e);
                                const s = [{ html: e.getAttribute(i) }];
                                new Ye(s);
                            }
                        });
                    });
        }
    };
    const Js = {
            onLoad() {
                new Gs(this.container);
            },
        },
        Zs = {},
        to = "[data-mosaic-blocks]",
        eo = "[data-prev-arrow]",
        io = "[data-next-arrow]",
        so = "data-slide",
        oo = "data-slide-index",
        no = "flickity-enabled";
    let ro = class {
        init() {
            this.initMobileSlider(), document.addEventListener("theme:resize", this.sliderInitEvent);
        }
        initMobileSlider() {
            const t = theme.isMobile(),
                e = { wrapAround: !0, prevNextButtons: !1, pageDots: !1 },
                s = () => this.flkty.previous(!0),
                o = () => this.flkty.next(!0);
            t && !this.isInit()
                ? ((this.flkty = new i(this.slideshow, e)),
                  this.slideshowPrev &&
                      this.slideshowNext &&
                      (this.slideshowPrev.addEventListener("click", s),
                      this.slideshowNext.addEventListener("click", o)))
                : !t &&
                  this.isInit() &&
                  (this.flkty.destroy(),
                  this.slideshowPrev &&
                      this.slideshowNext &&
                      (this.slideshowPrev.removeEventListener("click", s),
                      this.slideshowNext.removeEventListener("click", o)));
        }
        isInit() {
            var t;
            return null === (t = this.slideshow) || void 0 === t ? void 0 : t.classList.contains(no);
        }
        onUnload() {
            this.isInit() && this.flkty.destroy(), document.removeEventListener("theme:resize", this.sliderInitEvent);
        }
        onBlockSelect(t) {
            const e = this.container.querySelector(`[${so}="${t.detail.blockId}"]`);
            this.isInit() && null !== e && this.flkty.select(parseInt(e.getAttribute(oo)));
        }
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(to)),
                (this.slideshowPrev = this.container.querySelector(eo)),
                (this.slideshowNext = this.container.querySelector(io)),
                (this.flkty = null),
                (this.sliderInitEvent = () => this.initMobileSlider()),
                this.init();
        }
    };
    ge("mosaic", [
        {
            onLoad() {
                Zs[this.id] = new ro(this);
            },
            onUnload(t) {
                Zs[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                Zs[this.id].onBlockSelect(t);
            },
        },
        Js,
    ]);
    const ao = ".input-group--error",
        co = "input.password, input.email";
    let lo = class {
        init() {
            this.inputGroups.forEach((t) => {
                t.querySelector(co).focus();
            });
        }
        constructor(t) {
            (this.container = t.container), (this.inputGroups = this.container.querySelectorAll(ao)), this.init();
        }
    };
    ge("password", {
        onLoad() {
            new lo(this);
        },
    });
    let ho = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") &&
                !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
                -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        read() {
            if (
                -1 !== document.cookie.indexOf("; ") &&
                document.cookie.split("; ").find((t) => t.startsWith(this.name))
            ) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        constructor(t, e, i) {
            (this.configuration = { expires: i, path: "/", domain: window.location.hostname }),
                (this.name = t),
                (this.value = e);
        }
    };
    const uo = "[data-popup]",
        po = "[data-popup-close]",
        mo = "popup--visible",
        vo = "data-delay",
        fo = "data-reappear_time",
        go = "data-testmode",
        yo = "true";
    let wo = {},
        bo = class {
            expireDate() {
                const t = new Date(),
                    e = new Date();
                let i = parseInt(this.popup.getAttribute(fo));
                return (
                    0 !== i ? e.setTime(t.getTime() + 864e5 * i) : e.setTime(t.getTime() + 31536e8),
                    (i = e.toGMTString()),
                    i
                );
            }
            init() {
                const t = !1 !== this.cookie.read(),
                    e = "/challenge" === window.location.pathname;
                -1 !== window.location.search.indexOf("?customer_posted=true") && (this.delay = 0),
                    ((!t && !e) || this.testmode) &&
                        (this.timeout = setTimeout(() => {
                            this.popup.classList.add(mo), this.initClosers(), this.close.focus();
                        }, this.delay));
            }
            initClosers() {
                this.close.addEventListener("click", this.closeModal.bind(this));
            }
            closeModal(t) {
                t.preventDefault(),
                    this.popup.classList.remove(mo),
                    clearTimeout(this.timeout),
                    this.testmode || this.cookie.write();
            }
            constructor(t) {
                (this.popup = t),
                    (this.close = this.popup.querySelector(po)),
                    (this.timeout = 0),
                    (this.testmode = this.popup.getAttribute(go) === yo),
                    (this.delay = 1e3 * parseInt(this.popup.getAttribute(vo))),
                    (this.cookie = new ho("newsletter", "user_has_closed", this.expireDate())),
                    this.init();
            }
        };
    ge("popup", [
        {
            onLoad() {
                const t = this.container.querySelector(uo);
                null !== t && (wo[this.id] = new bo(t));
            },
        },
    ]);
    const Eo = {},
        Lo = "#RecentlyViewed",
        So = "data-limit",
        ko = "[data-product-block]";
    let qo = class {
        init() {
            Shopify.Products.showRecentlyViewed({
                howManyToShow: this.limit,
                onComplete: () => {
                    this.container.querySelectorAll(ko).length > 0 && new Oi(this.container);
                },
            });
        }
        constructor(t) {
            (this.section = t),
                (this.container = t.container),
                (this.limit = parseInt(this.container.getAttribute(So))),
                (this.recentlyViewed = this.container.querySelector(Lo)),
                this.recentlyViewed && this.init();
        }
    };
    ge("recently-viewed-products", {
        onLoad() {
            Eo[this.id] = new qo(this);
        },
    });
    const Ao = {},
        Co = '[data-section-type="related-products"]',
        To = "[data-product-block]",
        xo = "data-section-id",
        Io = "data-product-id",
        Mo = "data-limit";
    let Ho = class {
        init() {
            const t = this.container,
                e = t.getAttribute(xo),
                i = t.getAttribute(Io),
                s = t.getAttribute(Mo),
                o = `${theme.routes.product_recommendations_url}?section_id=${e}&limit=${s}&product_id=${i}`;
            fetch(o)
                .then((t) => t.text())
                .then((e) => {
                    const i = document.createElement("div");
                    i.innerHTML = e;
                    const s = i.querySelector(Co);
                    s.querySelector(To) && ((t.innerHTML = s.innerHTML), new Oi(t));
                });
        }
        constructor(t) {
            (this.container = t.container), this.init();
        }
    };
    ge("related-products", {
        onLoad() {
            Ao[this.id] = new Ho(this);
        },
    });
    const Po = {},
        Fo = ".shopify-section",
        Bo = "[data-prev-arrow]",
        Do = "[data-next-arrow]",
        Wo = "data-options",
        _o = "data-style",
        Oo = "data-current-style",
        No = "data-slide",
        $o = "data-slide-index",
        Ro = "[data-button-scroll]",
        Vo = "hero--is-loading",
        Uo = "is-selected",
        zo = "flickity-enabled";
    let jo = class {
        init() {
            let t = JSON.parse(this.options.replace(/'/g, '"'));
            (t = {
                ...t,
                cellSelector: `[${No}]`,
                on: {
                    ready: () => {
                        requestAnimationFrame(() => {
                            this.container.classList.remove(Vo);
                        }),
                            this.slideActions();
                    },
                },
            }),
                (this.flkty = new o(this.container, t)),
                this.flkty.on("change", () => {
                    this.slideActions();
                }),
                this.slideshowPrev && this.slideshowPrev.addEventListener("click", () => this.flkty.previous(!0)),
                this.slideshowNext && this.slideshowNext.addEventListener("click", () => this.flkty.next(!0)),
                this.scrollBtn &&
                    this.scrollBtn.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = this.parentContainer.offsetTop,
                            i = this.parentContainer.offsetHeight;
                        scroll({ top: e + i - 59, behavior: "smooth" });
                    }),
                document.addEventListener("theme:scroll", this.checkVisibilityOnScroll);
        }
        isAutoplay() {
            return !1 !== this.flkty.options.autoPlay;
        }
        checkSliderVisibility() {
            if (!this.flkty) return;
            const t = this.container.classList.contains(zo);
            (window.visibilityHelper.isElementPartiallyVisible(this.container) ||
                window.visibilityHelper.isElementTotallyVisible(this.container)) &&
            t &&
            this.isAutoplay()
                ? this.flkty.playPlayer()
                : this.flkty.stopPlayer();
        }
        slideActions() {
            const t = this.container.querySelector(`.${Uo}`).getAttribute(_o);
            this.container.setAttribute(Oo, t);
        }
        onUnload() {
            this.flkty.destroy(), document.removeEventListener("theme:scroll", this.checkVisibilityOnScroll);
        }
        onBlockSelect(t) {
            const e = this.container.querySelector(`[${No}="${t.detail.blockId}"]`),
                i = parseInt(e.getAttribute($o));
            this.flkty.select(i), this.flkty.stopPlayer();
        }
        onBlockDeselect() {
            this.isAutoplay() && this.flkty.playPlayer();
        }
        constructor(t) {
            (this.container = t.container),
                (this.options = this.container.getAttribute(Wo)),
                (this.parentContainer = this.container.closest(Fo)),
                (this.slideshowPrev = this.parentContainer.querySelector(Bo)),
                (this.slideshowNext = this.parentContainer.querySelector(Do)),
                (this.scrollBtn = this.parentContainer.querySelector(Ro)),
                (this.checkVisibilityOnScroll = this.checkSliderVisibility()),
                (this.flkty = null),
                this.init();
        }
    };
    ge("slideshow", [
        {
            onLoad() {
                Po[this.id] = new jo(this);
            },
            onUnload(t) {
                Po[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                Po[this.id].onBlockSelect(t);
            },
            onBlockDeselect(t) {
                Po[this.id].onBlockDeselect(t);
            },
        },
    ]),
        ge("featured-video", [Js]),
        document.addEventListener("DOMContentLoaded", function () {
            ye("*");
            document.querySelectorAll("[data-anchor-link]").forEach((t) => {
                t.addEventListener("click", (e) => {
                    e.preventDefault();
                    const i =
                        document.getElementById(t.getAttribute("href").split("#")[1]).getBoundingClientRect().top +
                        window.scrollY -
                        theme.dimensions.headerScrolled;
                    window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                });
            });
            document
                .querySelectorAll(
                    '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
                )
                .forEach((t) => {
                    wrap(t, "rte__video-wrapper");
                }),
                window.self !== window.top && document.querySelector("html").classList.add("iframe");
        }),
        window.navigator.cookieEnabled &&
            (document.documentElement.className = document.documentElement.className.replace(
                "supports-no-cookies",
                "supports-cookies"
            ));
})(
    themeVendor.ScrollLock,
    themeVendor.ajaxinate,
    themeVendor.Flickity,
    themeVendor.FlickityAsNavFor,
    themeVendor.FlickityFade
);
